// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/neosans/NeoSans.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/neosans/NeoSans.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/neosans/NeoSans.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/neosans/NeoSans-Bold.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../assets/neosans/NeoSans-Bold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../assets/neosans/NeoSans-Bold.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 12 12%27%3E%3Cpath fill=%27%23D1D5DB%27 d=%27M6 9L1 4h10z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===== CHART LAYOUT ===== */

/* ===== Base Variables ===== */
:root {
  --white: #ffffff;
  --gray-33: #333333;
  --primary-74: #7479ff;
  --purple: #9b51e0;
  --green: #228b22;

  /* Font Size Variables - Standardized */
  --fs-page-title: 30px;
  --fs-section-header: 18px;
  --fs-chart-title: 20px;
  --fs-chart-label: 14px;
  --fs-chart-text: 14px;
  --fs-chart-small: 12px;
  --fs-chart-tiny: 11px;
  --fs-tab-button: 14px;
}

/* ===== Font Definitions ===== */
@font-face {
  font-family: "NeoSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: "NeoSans";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff2"),
    url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff"),
    url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("truetype");
  font-weight: bold;
  font-style: normal;
}

/* ===== Utility Classes ===== */
.glass-card-ui {
  background: rgba(51, 51, 51, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 16px;
  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3),
    2px 0 2px rgba(255, 255, 255, 0.3) !important;
  border-left: 1px solid rgba(255, 255, 255, 0.1); /* Side borders normal */
  border-right: 1px solid rgba(255, 255, 255, 0.1); /* Side borders normal */
  border-top: 1px solid rgba(255, 255, 255, 0.01); /* Top much more transparent */
  border-bottom: 1px solid rgba(255, 255, 255, 0.01); /* Bottom much more transparent */
}

/* ===== Font Size Utility Classes ===== */
/* Use these classes throughout chart components for consistency */
.chart-page-title {
  font-size: var(--fs-page-title);
  font-weight: 600;
  color: var(--white);
}

.chart-section-header {
  font-size: var(--fs-section-header);
  font-weight: 500;
  color: var(--white);
}

.chart-title {
  font-size: var(--fs-chart-title);
  font-weight: 600;
  color: var(--white);
}

.chart-subtitle {
  font-size: var(--fs-section-header);
  font-weight: 400;
  color: rgba(255, 255, 255, 0.8);
}

.chart-label {
  font-size: var(--fs-chart-label);
  font-weight: 400;
  color: rgba(255, 255, 255, 0.9);
}

.chart-text {
  font-size: var(--fs-chart-text);
  font-weight: 400;
  color: rgba(255, 255, 255, 0.9);
}

.chart-small {
  font-size: var(--fs-chart-small);
  font-weight: 400;
  color: rgba(255, 255, 255, 0.7);
}

.chart-tiny {
  font-size: var(--fs-chart-tiny);
  font-weight: 400;
  color: rgba(255, 255, 255, 0.6);
}

/* ===== Transparent Button Styling ===== */
/* Base transparent button with glassmorphism effect */
.btn-transparent {
  background: rgba(51, 51, 51, 0.3);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 8px 12px;
  color: #d1d5db;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  transition: all 0.2s ease;
  white-space: nowrap;

  /* Flex layout for icon + text alignment */
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Transparent button hover effects */
.btn-transparent:hover {
  background: rgba(75, 85, 99, 0.4);
  border-color: rgba(255, 255, 255, 0.2);
  color: #f3f4f6;
}

/* Transparent button disabled state */
.btn-transparent:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Icon container within transparent button */
.btn-transparent .btn-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0; /* Prevent icon from shrinking */
}

/* Text container within transparent button */
.btn-transparent .btn-text {
  flex: 1 1;
  text-align: left;
}

.chart-btn {
  background: rgba(51, 51, 51, 0.3);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 8px 14px;
  color: #d1d5db;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 14px;
  font-weight: 400;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.chart-btn:hover {
  background: rgba(75, 85, 99, 0.4);
  border-color: rgba(255, 255, 255, 0.2);
  color: #f3f4f6;
}

.chart-btn.active {
  background: rgba(139, 92, 246, 0.3);
  border-color: rgba(139, 92, 246, 0.5);
  color: #c4b5fd;
}

.chart-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.chart-btn-icon-only {
  padding: 8px;
  min-width: 36px;
  justify-content: center;
}

/* Chart type selector pills container */
.chart-type-selector {
  display: flex;
  gap: 0;
  padding: 0;
  background: rgba(51, 51, 51, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 30px;
  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3),
    2px 0 2px rgba(255, 255, 255, 0.3) !important;
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  border-top: 1px solid rgba(255, 255, 255, 0.01);
  border-bottom: 1px solid rgba(255, 255, 255, 0.01);
  align-items: center;
  height: fit-content;
}

.chart-type-selector .chart-btn-icon-only {
  background: transparent !important;
  border: none !important;
  border-radius: 30px;
  padding: 8px 14px;
  min-width: 40px;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
  box-shadow: none !important;
  flex: 1 1;
}

.chart-type-selector .chart-btn-icon-only:hover {
  background: transparent !important;
  border: none !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
  box-shadow: none !important;
}

.chart-type-selector .chart-btn-icon-only.active {
  background: rgba(255, 255, 255, 0.1125);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-radius: 30px;
  box-shadow: -1px 0 1px rgba(255, 255, 255, 0.15),
    1px 0 1px rgba(255, 255, 255, 0.15) !important;
  border-left: 0.5px solid rgba(255, 255, 255, 0.075) !important;
  border-right: 0.5px solid rgba(255, 255, 255, 0.075) !important;
  border-top: 0.5px solid rgba(255, 255, 255, 0.0075) !important;
  border-bottom: 0.5px solid rgba(255, 255, 255, 0.0075) !important;
  color: #fff;
}

/* Individual styled buttons with forecast popup styling */
.chart-btn-styled {
  background: rgba(51, 51, 51, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 30px;
  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3),
    2px 0 2px rgba(255, 255, 255, 0.3) !important;
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  border-top: 1px solid rgba(255, 255, 255, 0.01);
  border-bottom: 1px solid rgba(255, 255, 255, 0.01);
}

.chart-btn-styled:hover {
  background: rgba(75, 85, 99, 0.4);
  border-left: 1px solid rgba(255, 255, 255, 0.2);
  border-right: 1px solid rgba(255, 255, 255, 0.2);
}

.chart-input {
  background: rgba(51, 51, 51, 0.3);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 8px 16px;
  color: #d1d5db;
  font-size: 14px;
  outline: none;
  transition: all 0.2s ease;
}

.chart-input::placeholder {
  color: #9ca3af;
}

.chart-input:focus {
  border-color: rgba(139, 92, 246, 0.5);
  box-shadow: 0 0 0 2px rgba(139, 92, 246, 0.1);
}

.chart-search-container {
  position: relative;
  display: flex;
  align-items: center;
  background: rgba(51, 51, 51, 0.3);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  padding: 8px 16px;
  gap: 8px;
  transition: all 0.2s ease;
}

.chart-search-container:focus-within {
  border-color: rgba(139, 92, 246, 0.5);
  box-shadow: 0 0 0 2px rgba(139, 92, 246, 0.1);
}

.chart-search-input {
  background: transparent;
  border: none;
  outline: none;
  color: #d1d5db;
  font-size: 14px;
  width: 200px;
}

.chart-search-input::placeholder {
  color: #9ca3af;
}

/* ===== Chart Header ===== */
.chart-title {
  font-size: 24px;
  color: var(--white);
  font-weight: bold;
}

.chart-subtitle {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
}

.chart-price {
  font-size: 24px;
  color: var(--white);
  font-weight: bold;
}

.chart-price-date {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
}

.chart-price-change {
  font-size: 14px;
  color: var(--green);
}

.chart-header-actions {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 1.5rem 0;
  gap: 1rem;
  flex-wrap: wrap;
}

/* ===== Process Steps Component ===== */
.process-steps-container {
  display: flex;
  align-items: center;
  width: 100%;
}

.process-steps-group {
  display: flex;
  align-items: center;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  overflow: hidden;
  box-shadow: none !important;
}

.process-step-main {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  padding: 12px 24px;
  border-radius: 20px;
  color: #fff;
  border: none;
  box-shadow: none;
}

.process-step-main.expanded {
  border-radius: 20px 0 0 20px !important;
  border: none;
  box-shadow: none;
  position: relative;
  overflow: hidden;
}

.process-step-main.expanded::after {
  content: '';
  position: absolute;
  top: 0;
  right: -1px;
  width: 2px;
  height: 100%;
  background: inherit;
  z-index: 1;
}

.process-steps-expanding-wrapper {
  display: flex;
  align-items: center;
  transition: all 0.4s ease-in-out;
  max-width: 0;
  overflow: hidden;
  height: 100%;
  border: none;
  box-shadow: none;
}

.process-steps-expanding-wrapper.expanded {
  max-width: 1000px; /* Set a max-width large enough to contain all buttons */
}

.process-step {
  position: relative;
}

.process-step::before {
  content: '';
  position: absolute;
  border-radius: 20px;
  left: 0;
  top: 0%;
  bottom: 20%;
  width: 1px;
  background: linear-gradient(to bottom,
              transparent 0%,
              rgba(255, 255, 255, 0.3) 20%,
              rgba(255, 255, 255, 0.3) 80%,
              transparent 100%);
  z-index: 1;
}

.process-step-btn {
  white-space: nowrap;
  border-radius: 0;
  margin-left: 0;
  padding: 16px 28px;
  color: #fff;
  background: transparent;
  border: none;
  border-left: 1px solid rgba(255, 255, 255, 0.3);
  border-top: none;
  border-right: none;
  border-bottom: none;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2),
              inset 0 1px 0 rgba(255, 255, 255, 0.05);
  outline: none;
  transition: all 0.3s ease;
  gap: 12px;
}
.process-step-icon {
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.process-step-btn:last-child {
  border-radius: 0 20px 20px 0;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2),
              inset 0 1px 0 rgba(255, 255, 255, 0.05),
              0 0 0 1px rgba(255, 255, 255, 0.05);
}

.process-step-btn:hover {
  background: rgba(255, 255, 255, 0.05);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3),
              inset 0 1px 0 rgba(255, 255, 255, 0.1),
              0 0 0 1px rgba(255, 255, 255, 0.1);
  transform: translateY(-1px);
}


.process-steps-expanding-wrapper.expanded .process-step-btn {
  margin-left: 0;
}

/* Override any inherited shadows and borders from TransparentButton */
.process-steps-expanding-wrapper .process-step-btn,
.process-steps-expanding-wrapper .process-step-btn * {
  box-shadow: none !important;
  border: none !important;
  outline: none !important;
}

.process-step-tooltip {
  position: fixed;
  transform: translateX(0);
  z-index: 9999;
  min-width: 300px;
  max-width: 400px;
  pointer-events: none;
  animation: fadeInUp 0.2s ease-out;
}

.process-step-tooltip-card {
  background: rgba(255, 255, 255, 0.05) !important;
  backdrop-filter: blur(20px) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3) !important;
  padding: 20px !important;
  border-radius: 12px !important;
}

.process-step-tooltip-title {
  color: #ffffff;
  margin-bottom: 12px;
  font-size: 16px;
  font-weight: 600;
}

.process-step-tooltip-description {
  color: rgba(255, 255, 255, 0.8);
  font-size: 14px;
  line-height: 1.5;
  margin: 0;
}

.process-step-tooltip-arrow {
  position: absolute;
  top: -6px;
  left: 20px;
  transform: translateX(0);
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  border-bottom: 6px solid rgba(255, 255, 255, 0.2);
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateX(-50%) translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateX(-50%) translateY(0);
  }
}

/* ===== Co2 Value Card ===== */
.co2-value-card {
  margin-left: auto;
  padding: 12px 24px;
  border-radius: 20px;
  background: rgba(51, 51, 51, 0.3);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  min-width: fit-content;
  white-space: nowrap;
}

.co2-value-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 12px;
}

.co2-value-label {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.7);
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.co2-value-data {
  display: flex;
  align-items: center;
  gap: 8px;
}

.co2-value-amount {
  font-size: 16px;
  color: #ffffff;
  font-weight: 600;
}

.co2-value-icon {
  color: #87ceeb;
  font-size: 22px;
}

/* ===== Main Chart Styling ===== */
.main-chart-container {
  background: transparent;
  padding: 0;
  margin: 0.25rem 0;
}

.chart-area {
  background: rgba(17, 24, 39, 0.3);
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  border-radius: 12px;
  padding: 8px 8px 12px 8px;
  border: 1px solid rgba(255, 255, 255, 0.05);
  margin-bottom: 16px;
}

.chart-history-navigator {
  background: transparent;
  padding: 0;
  margin-top: 16px;
}

.chart-history-title {
  color: #d1d5db;
  font-size: 14px;
  font-weight: 500;
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.chart-history-subtitle {
  color: #9ca3af;
  font-size: 12px;
  font-weight: 400;
  margin-left: auto;
}

.chart-history-overview {
  position: relative;
  height: 120px;
  background: transparent;
  border-radius: 8px;
  overflow: hidden;
  -webkit-user-select: none;
          user-select: none;
}

.chart-history-slider {
  position: absolute;
  top: 10px;
  height: calc(100% - 20px);
  background: rgba(139, 92, 246, 0.15);
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
  border: 2px solid rgba(139, 92, 246, 0.8);
  border-radius: 16px;
  cursor: grab;
  z-index: 10;
  transition: all 0.3s ease;
  min-width: 20px;
  box-shadow: 0 0 0 1px rgba(139, 92, 246, 0.3);
}

.chart-history-slider:hover {
  background: rgba(139, 92, 246, 0.2);
  border-color: rgba(139, 92, 246, 0.9);
  box-shadow: 0 0 0 1px rgba(139, 92, 246, 0.4);
}

.chart-history-slider.dragging {
  cursor: grabbing;
  background: rgba(139, 92, 246, 0.25);
  border-color: rgba(139, 92, 246, 1);
  box-shadow: 0 0 0 1px rgba(139, 92, 246, 0.5);
}

.chart-history-handle {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 12px;
  height: 24px;
  background: rgba(139, 92, 246, 0.9);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 6px;
  cursor: ew-resize;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);
}

.chart-history-handle::after {
  content: "";
  width: 2px;
  height: 12px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 1px;
}

.chart-history-handle.left {
  left: -6px;
}

.chart-history-handle.right {
  right: -6px;
}

.chart-history-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
  font-size: 12px;
  color: #9ca3af;
}

.chart-history-info {
  display: flex;
  gap: 16px;
  align-items: center;
}

.chart-history-warning {
  color: #f59e0b;
  font-size: 11px;
  background: rgba(245, 158, 11, 0.1);
  padding: 2px 6px;
  border-radius: 4px;
}

/* ===== Chart Legend ===== */
.chart-legend-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
  margin-top: 16px;
}

.chart-legend-group {
  display: flex;
  gap: 12px;
  align-items: center;
}

.chart-legend-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 36px;
  background: rgba(51, 51, 51, 0.1);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 30px;
  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.15),
    2px 0 2px rgba(255, 255, 255, 0.15) !important;
  border-left: 1px solid rgba(255, 255, 255, 0.05);
  border-right: 1px solid rgba(255, 255, 255, 0.05);
  border-top: 1px solid rgba(255, 255, 255, 0.005);
  border-bottom: 1px solid rgba(255, 255, 255, 0.005);
  color: #d1d5db;
  cursor: pointer;
  font-size: 14px;
  font-weight: 400;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.chart-legend-btn:hover {
  background: transparent;
  border-left: 1px solid rgba(255, 255, 255, 0.05);
  border-right: 1px solid rgba(255, 255, 255, 0.05);
  color: #f3f4f6;
}

.chart-legend-btn.active {
  background: transparent;
  border-left: 1px solid rgba(255, 255, 255, 0.05);
  border-right: 1px solid rgba(255, 255, 255, 0.05);
  border-top: 1px solid rgba(255, 255, 255, 0.005);
  border-bottom: 1px solid rgba(255, 255, 255, 0.005);
  color: #fff;
}

/* Value and Forecast buttons as two halves of one pill */
.chart-legend-group {
  display: flex;
  gap: 0;
  padding: 0;
  background: rgba(51, 51, 51, 0.1);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 30px;
  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.15),
    2px 0 2px rgba(255, 255, 255, 0.15) !important;
  border-left: 1px solid rgba(255, 255, 255, 0.05);
  border-right: 1px solid rgba(255, 255, 255, 0.05);
  border-top: 1px solid rgba(255, 255, 255, 0.005);
  border-bottom: 1px solid rgba(255, 255, 255, 0.005);
  align-items: center;
  overflow: hidden;
  min-width: fit-content;
}

.chart-legend-group .chart-legend-btn {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
  position: relative;
  padding: 8px 24px;
  min-width: fit-content;
  white-space: nowrap;
}

.chart-legend-group .chart-legend-btn:not(:last-child)::after {
  content: '';
  position: absolute;
  right: 0;
  top: 20%;
  bottom: 20%;
  width: 1px;
  background: rgba(255, 255, 255, 0.1);
}

.chart-legend-group .chart-legend-btn.active {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  border-radius: 0 !important;
}

.chart-legend-group .chart-legend-btn:hover {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

.chart-legend-group.forecast-unavailable {
  opacity: 0.6;
}

.chart-legend-btn.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

.chart-legend-btn.inactive {
  opacity: 0.45;
  filter: grayscale(0.4);
}

.forecast-loading-overlay {
  position: absolute;
  inset: 0;
  background: rgba(3, 7, 18, 0.35);
  backdrop-filter: blur(2px);
  -webkit-backdrop-filter: blur(2px);
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  z-index: 4;
  pointer-events: none;
}

.forecast-loading-card {
  min-width: 220px;
  padding: 12px 14px;
  border-radius: 12px;
  background: rgba(15, 23, 42, 0.75);
  border: 1px solid rgba(148, 163, 184, 0.2);
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.forecast-loading-placeholder {
  width: 100%;
  height: 10px;
  border-radius: 999px;
  background: linear-gradient(90deg, rgba(148, 163, 184, 0.18), rgba(148, 163, 184, 0.32), rgba(148, 163, 184, 0.18));
  background-size: 200% 100%;
  animation: forecast-shimmer 1.4s ease-in-out infinite;
}

.forecast-loading-placeholder-short {
  width: 65%;
}

.forecast-loading-text {
  font-size: 13px;
  color: #e5e7eb;
  font-weight: 500;
}

@keyframes forecast-shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}

.chart-legend-dot {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  flex-shrink: 0;
  border: 3px solid;
  border-color: inherit;
  background: transparent;
}

/* ===== Chart Card Container ===== */
.chart-card-container {
  /* background: rgba(51, 51, 51, 0.2); */
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 20px;
  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3),
    2px 0 2px rgba(255, 255, 255, 0.3) !important;
  margin: 1.5rem 0;
  overflow: hidden;
}

.chart-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(17, 24, 39, 0.3);
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px 16px 0 0;
  padding: 16px 20px;
  margin-bottom: 0;
  transition: border-radius 0.4s ease;
}

/* When collapsed, header should have rounded bottom corners */
.chart-card-container.collapsed .chart-card-header {
  border-radius: 16px;
}

.chart-card-title-section {
  display: flex;
  align-items: center;
  gap: 12px;
}

.chart-card-grid-icon {
  display: flex;
  align-items: center;
  justify-content: center;
}

.grid-dots {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2px;
  width: 12px;
  height: 12px;
}

.grid-dots span {
  width: 4px;
  height: 4px;
  background: #9ca3af;
  border-radius: 1px;
}

.action-icon {
  width: 40px;
  height: 40px;
  object-fit: cover;
  display: block;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.action-icon:hover {
  opacity: 0.8;
  transform: scale(1.05);
}

.chart-card-title {
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.chart-card-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.chart-card-action-btn {
  background: rgba(75, 85, 99, 0.3);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 6px;
  padding: 0 !important;
  color: #9ca3af;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
  width: 40px;
  height: 40px;
  overflow: hidden;
}

.chart-card-action-btn:hover {
  background: rgba(75, 85, 99, 0.5);
  border-color: rgba(255, 255, 255, 0.2);
  color: #d1d5db;
}

.chart-card-content {
  background: rgba(17, 24, 39, 0.3);
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  /* border: 1px solid rgba(255, 255, 255, 0.05); */
  border-top: none;
  border-radius: 0 0 16px 16px;
  padding: 24px;
  min-height: auto;
  max-height: 5000px;
  overflow: hidden;
  transition: max-height 0.4s ease, padding 0.4s ease, opacity 0.3s ease;
  opacity: 1;
}

.chart-card-content.collapsed {
  max-height: 0;
  padding-top: 0;
  padding-bottom: 0;
  opacity: 0;
}

/* Rotate the action icon when collapsed */
.action-icon {
  transition: transform 0.3s ease;
  transform: rotate(0deg);
}

.action-icon.collapsed {
  transform: rotate(180deg);
}

/* ===== Drag and Drop Styles ===== */
.draggable-component {
  cursor: default;
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.draggable-component.dragging {
  opacity: 0.5;
  transform: scale(0.98);
}

.drag-handle {
  cursor: grab;
  transition: transform 0.2s ease;
}

.drag-handle:active {
  cursor: grabbing;
}

.drag-handle:hover {
  cursor: grab;
}

.drag-handle:hover .grid-dots span {
  background: #7479ff;
}

/* ===== Table & Average Layout ===== */
.table-average-layout {
  display: flex;
  gap: 20px;
  align-items: stretch;
  width: 100%;
}

.table-section {
  flex: 1 1 50%;
  min-width: 0; /* Prevents flex item from overflowing */
  max-width: 50%;
  background: rgba(17, 24, 39, 0.4);
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.05),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
  overflow: hidden; /* Prevent content overflow */
}

.chart-section {
  flex: 1 1 50%;
  min-width: 0; /* Prevents flex item from overflowing */
  max-width: 50%;
  overflow: hidden; /* Prevent content overflow */
  display: flex;
  flex-direction: column;
}

.chart-section > * {
  max-width: 100%;
  width: 100%;
}

@media (max-width: 1024px) {
  .table-average-layout {
    gap: 16px;
  }

  .table-section {
    flex: 1 1 50%;
    max-width: 50%;
    padding: 12px;
  }

  .chart-section {
    flex: 1 1 50%;
    max-width: 50%;
  }
}

@media (max-width: 768px) {
  .table-average-layout {
    flex-direction: column;
    gap: 12px;
  }

  .table-section,
  .chart-section {
    flex: 1 1 100%;
    max-width: 100%;
    min-width: 0;
  }

  .table-section {
    padding: 10px;
  }
}

/* ===== Glass Table Improvements ===== */
.glass-table {
  /* background: rgba(31, 41, 55, 0.3) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
 
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2),
              inset 0 1px 0 rgba(255, 255, 255, 0.1); */
  border-radius: 20px;
}

.glass-table th {
  color: #ffffff !important;
  font-weight: 600 !important;
  font-size: 13px !important;
  padding: 12px !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
  text-align: center !important;
  background: rgba(255, 255, 255, 0.05);
}

.glass-table td {
  color: #ffffff !important;
  padding: 12px !important;
  font-size: 13px !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.05) !important;
  text-align: center !important;
  background: rgba(255, 255, 255, 0.02);
}

.glass-table tr:hover td {
  background: rgba(255, 255, 255, 0.05) !important;
}

.glass-table .change-negative {
  color: #ef4444 !important;
  font-weight: 500 !important;
}

.glass-table .change-positive {
  color: #10b981 !important;
  font-weight: 500 !important;
}

/* ===== Risk & Recycling Layout ===== */
.risk-recycling-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  align-items: stretch;
}

.risk-card {
  border-radius: 1.5rem;
  padding: 1.5rem;
  color: white;
  background: rgba(51, 51, 51, 0.2);
  backdrop-filter: blur(10px);
  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3), 2px 0 2px rgba(255, 255, 255, 0.3);
  -webkit-backdrop-filter: blur(15px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  min-height: auto;
  transition: all 0.3s ease;
}

.risk-card:hover {
  background: rgba(17, 24, 39, 0.7);
  border-color: rgba(255, 255, 255, 0.2);
  transform: translateY(-2px);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.1),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

.risk-card-title {
  color: #ffffff;
  font-size: 16px;
  font-weight: 600;
  margin: 16px 0 12px 0;
  text-align: center;
}

.risk-card-description {
  color: #9ca3af;
  font-size: 13px;
  line-height: 1.4;
  text-align: center;
  margin-top: 12px;
}

@media (max-width: 1024px) {
  .risk-recycling-grid {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .risk-card {
    min-height: 240px;
    padding: 20px;
  }
}

@media (max-width: 768px) {
  .risk-recycling-grid {
    gap: 12px;
  }

  .risk-card {
    min-height: 220px;
    padding: 16px;
  }
}

/* ===== Gauge Chart Styling ===== */
.gauge-chart-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.gauge-chart-svg-wrapper {
  position: relative;
  margin-bottom: 16px;
}

.gauge-chart-value {
  position: absolute;
  top: 70%;
  left: 50%;
  transform: translateX(-50%);
  color: #ffffff;
  font-size: 27px;
  font-weight: 700;
  text-align: center;
}

.gauge-chart-title {
  color: #ffffff;
  font-size: 18px;
  font-weight: 600;
  margin: 12px 0 8px 0;
  text-align: center;
}

.gauge-chart-description {
  color: #9ca3af;
  font-size: 16px;
  line-height: 1.4;
  text-align: center;
  margin: 0;
}

/* ===== Risk Assessment Chart Styling ===== */
.risk-assessment-chart-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.risk-assessment-chart-wrapper {
  position: relative;
  margin-bottom: 16px;
}

.risk-assessment-chart-svg-container {
  position: relative;
  display: inline-block;
}

.risk-assessment-center-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  pointer-events: none;
}

.risk-assessment-percentage {
  color: #ffffff;
  font-size: 26px;
  font-weight: 700;
  line-height: 1;
  margin-bottom: 2px;
}

.risk-assessment-label {
  color: #9ca3af;
  font-size: 16.5px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.risk-assessment-title {
  color: #ffffff;
  font-size: 18px;
  font-weight: 600;
  margin: 12px 0 8px 0;
  text-align: center;
}

.risk-assessment-description {
  color: #9ca3af;
  font-size: 16px;
  line-height: 1.4;
  text-align: center;
  margin: 0;
}

.risk-assessment-progress-arc {
  transition: stroke-dashoffset 0.8s ease-in-out;
}

/* ===== Water Filling Chart Styling ===== */
.water-filling-chart-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
}

.water-filling-chart-wrapper {
  position: relative;
  margin-bottom: 16px;
}

.water-filling-chart-svg-container {
  position: relative;
  display: inline-block;
}

.water-filling-center-text {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  pointer-events: none;
}

.water-filling-percentage {
  color: #ffffff;
  font-size: 26px;
  font-weight: 700;
  line-height: 1;
}

.water-filling-title {
  color: #ffffff;
  font-size: 18px;
  font-weight: 600;
  margin: 12px 0 8px 0;
  text-align: center;
}

.water-filling-description {
  color: #9ca3af;
  font-size: 16px;
  line-height: 1.4;
  text-align: center;
  margin: 0;
}

/* ===== Availability & Need Layout ===== */
.availability-need-layout {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  align-items: stretch;
  width: 100%;
}

.availability-section,
.need-section {
  background: rgba(17, 24, 39, 0.4);
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.05),
    inset 0 1px 0 rgba(255, 255, 255, 0.1);
  min-height: 400px;
  display: flex;
  flex-direction: column;
}

@media (max-width: 1024px) {
  .availability-need-layout {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .availability-section,
  .need-section {
    min-height: 350px;
    padding: 16px;
  }
}

@media (max-width: 768px) {
  .availability-need-layout {
    gap: 12px;
  }

  .availability-section,
  .need-section {
    min-height: 300px;
    padding: 12px;
  }
}

/* ===== Commodity Chart Styling ===== */
.commodity-availability-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  padding: 0px 20px 0px 20px;
  background: transparent;
}

.commodity-header {
  margin-bottom: 20px;
}

.commodity-title {
  color: #ffffff;
  font-size: 22px;
  font-weight: 600;
  margin: 0 0 16px 0;
}

.commodity-data-labels {
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: center;
}

.commodity-label {
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
}

.commodity-chart-area {
  flex: 1 1;
  height: 240px;
  margin-bottom: 12px;
  display: block;
}

.commodity-description {
  color: #9ca3af;
  font-size: 13px;
  line-height: 1.4;
  margin: 0;
  margin-top: auto;
}

/* ===== Commodity Need Projection ===== */
.commodity-need-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  background: transparent;
  align-items: stretch;
}

.commodity-need-title {
  color: #ffffff;
  font-size: 22px;
  font-weight: 600;
  margin: 0 0 16px 0;
  align-self: stretch;
}

.commodity-need-chart {
  flex: 1 1;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  justify-content: stretch;
  width: 100%;
  overflow: visible;
}

.commodity-need-legend {
  display: flex;
  justify-content: flex-start;
  gap: 24px;
  margin-bottom: 16px;
  margin-left: 0;
  flex-wrap: wrap;
}

.commodity-need-legend-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.commodity-need-legend-color {
  width: 16px;
  height: 16px;
  border-radius: 3px;
}

.commodity-need-legend-text {
  color: #ffffff;
  font-size: 14px;
  font-weight: 500;
}

.commodity-need-description {
  color: #9ca3af;
  font-size: 13px;
  line-height: 1.4;
  margin: 0;
  text-align: left;
  width: 100%;
}

/* ===== Availability & Need Layout ===== */
.availability-need-layout {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 16px;
  height: 100%;
}

.availability-section {
  background: rgba(51, 51, 51, 0.15);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 16px;
  padding: 20px 0;
  border: 1px solid rgba(255, 255, 255, 0.08);
  width: 100%;
}

.need-section {
  background: rgba(51, 51, 51, 0.15);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 16px;
  padding: 20px 0px 20px 0px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  width: 100%;
}

@media (max-width: 1024px) {
  .availability-need-layout {
    grid-template-columns: 1fr;
    gap: 20px;
  }
}

/* ===== CO2 Calculator ===== */
.co2-calculator-title {
  color: #ffffff;
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 20px 0;
}

.co2-controls {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.co2-toggles {
  display: flex;
  align-items: center;
  gap: 20px;
  flex-wrap: wrap;
}

.co2-dropdown-buttons {
  display: flex;
  align-items: center;
  gap: 8px;
}

.co2-chart-subtitle {
  color: #ffffff;
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 20px 0;
}

.co2-chart-area {
  flex: 1 1;
}

.co2-toggle {
  display: flex;
  align-items: center;
  gap: 12px;
}

.co2-toggle-label {
  color: #e6e8f0;
  font-size: 14px;
  font-weight: 500;
}

.co2-toggle-switch {
  width: 48px;
  height: 26px;
  border-radius: 26px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  display: inline-flex;
  align-items: center;
  padding: 2px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
}

.co2-toggle-switch.on {
  background: #16d07f;
}

.co2-toggle-switch.off {
  background: #3a3a48;
}

.co2-toggle-switch.off.price {
  background: #cc3f3f;
}

.co2-toggle-knob {
  width: 20px;
  height: 20px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.95);
  transition: transform 0.3s ease;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);
}

.co2-toggle-switch.on .co2-toggle-knob {
  transform: translateX(22px);
}

@media (max-width: 768px) {
  .co2-controls {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .co2-toggles {
    width: 100%;
    justify-content: flex-start;
  }

  .co2-dropdown-buttons {
    width: 100%;
    justify-content: flex-start;
  }
}

/* ===== Charts Page Layout ===== */
.charts_page {
  padding: 20px;
  min-height: 100vh;
  max-width: 100vw;
  overflow-x: hidden;
}

.charts_page .charts_content {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  max-width: 100%;
}

.charts_page .center_column {
  width: 100%;
  min-width: 0;
}

.charts_page .right_column {
  width: 100%;
  min-width: 0;
  order: -1; /* Show right column (tabs) first on mobile/tablet */
}

/* Tablet breakpoint */
@media (min-width: 768px) and (max-width: 1024px) {
  .charts_page {
    padding: 16px;
  }

  .charts_page .charts_content {
    gap: 16px;
  }
}

/* Laptop and larger screens */
@media (min-width: 1025px) {
  .charts_page .charts_content {
    grid-template-columns: 1fr 380px;
    gap: 20px;
  }

  .charts_page .center_column {
    min-width: 0;
    overflow: visible;
  }

  .charts_page .right_column {
    width: 380px;
    min-width: 320px;
    order: 0; /* Reset order for desktop */
  }
}

/* Large desktop screens */
@media (min-width: 1440px) {
  .charts_page .charts_content {
    grid-template-columns: 1fr 420px;
    gap: 24px;
  }

  .charts_page .right_column {
    width: 420px;
  }
}

/* Mobile specific adjustments */
@media (max-width: 600px) {
  .charts_page {
    padding: 12px;
  }

  .charts_page .charts_content {
    gap: 12px;
  }

  /* Add horizontal scroll for chart header actions if needed */
  .chart-header-actions {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    -ms-overflow-style: none;
  }

  .chart-header-actions::-webkit-scrollbar {
    display: none;
  }
}

/* ===== Supplier Tab Component Styling ===== */
/* Main container for the supplier tab component */
.supplier-tab-container {
  color: #ffffff;
}

/* Header row with column labels */
.supplier-tab-header {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 16px;
  margin-bottom: 16px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  font-weight: 500;
}

/* Container for the list of supplier cards */
.supplier-tab-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

/* Individual supplier card styling */
.supplier-tab-card {
  transition: all 0.3s ease;
  cursor: pointer;
}

/* Main row displaying supplier basic info */
.supplier-tab-row {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr auto;
  gap: 16px;
  align-items: center;
}

/* Supplier name styling */
.supplier-tab-name {
  color: #ffffff;
  font-weight: 500;
  font-size: 14px;
}

/* Supplier location styling */
.supplier-tab-location {
  color: #ffffff;
  font-size: 14px;
}

/* Volume container with volume and percentage */
.supplier-tab-volume {
  display: flex;
  align-items: center;
  gap: 8px;
}

/* Volume text styling */
.supplier-tab-volume-text {
  color: #ffffff;
  font-size: 14px;
}

/* Percentage styling with emphasis */
.supplier-tab-percentage {
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
}

/* Chevron icon container */
.supplier-tab-chevron {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* Chevron icon styling */
.supplier-tab-chevron-icon {
  color: #ffffff;
  width: 16px;
  height: 16px;
  transition: transform 0.2s ease;
}

/* Expanded content container with animation */
.supplier-tab-expanded {
  margin-top: 16px;
  padding-top: 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  animation: supplier-tab-fade-in 0.3s ease-out;
}

/* Supplier description text */
.supplier-tab-description {
  font-size: 13px;
  color: rgba(255, 255, 255, 0.7);
  line-height: 1.5;
  margin: 0 0 16px 0;
}

/* Details grid container */
.supplier-tab-details-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0;
  margin-bottom: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 8px;
  overflow: hidden;
}

/* Individual detail item */
.supplier-tab-detail-item {
  display: flex;
  justify-content: space-between;
  padding: 12px 16px;
}

/* Right border for left column items */
.supplier-tab-detail-border-right {
  border-right: 1px solid rgba(255, 255, 255, 0.1);
}

/* Bottom border for top/middle row items */
.supplier-tab-detail-border-bottom {
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

/* Detail label styling */
.supplier-tab-detail-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
}

/* Detail value styling */
.supplier-tab-detail-value {
  font-size: 12px;
  color: #ffffff;
}

/* Profile button container */
.supplier-tab-profile-button {
  text-align: right;
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}

/* Supplier details table */
.supplier-tab-details-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  margin-bottom: 16px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  overflow: hidden;
}

.supplier-tab-detail-cell {
  padding: 12px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  vertical-align: top;
}

.supplier-tab-detail-cell .supplier-tab-detail-label {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  margin-bottom: 4px;
  font-weight: 500;
}

.supplier-tab-detail-cell .supplier-tab-detail-value {
  color: #ffffff;
  font-size: 13px;
  font-weight: 500;
}

/* Fade-in animation for expanded content */
@keyframes supplier-tab-fade-in {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* ===== COMPARE DROPDOWN STYLES ===== */
.compare-dropdown-container {
  position: relative;
  display: block;
  width: 100%;
}

.compare-dropdown-container .chart-search-container {
  position: relative;
  display: flex;
  align-items: center;
  background: rgba(51, 51, 51, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  padding: 8px 12px;
  width: 100%;
  cursor: pointer;
  transition: all 0.2s ease;
}

.compare-dropdown-container .chart-search-container:hover,
.compare-dropdown-container .chart-search-container.active {
  border-color: rgba(255, 255, 255, 0.2);
  background: rgba(51, 51, 51, 0.3);
}

.compare-dropdown-container .chart-search-input {
  flex: 1 1;
  background: transparent;
  border: none;
  outline: none;
  color: #fff;
  font-size: 14px;
  font-family: 'NeoSans', sans-serif;
  margin-left: 8px;
  margin-right: 8px;
  cursor: pointer;
}

.compare-dropdown-container .chart-search-input::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.compare-dropdown-menu {
  position: absolute;
  top: calc(100% + 8px);
  left: 50%;
  transform: translateX(-50%);
  background: rgba(51, 51, 51, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 20px;
  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3),
    2px 0 2px rgba(255, 255, 255, 0.3) !important;
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  border-top: 1px solid rgba(255, 255, 255, 0.01);
  border-bottom: 1px solid rgba(255, 255, 255, 0.01);
  z-index: 1000;
  min-width: 480px;
  width: 480px;
  max-width: 90vw;
  max-height: 400px;
  overflow: hidden;
}

.compare-dropdown-tabs {
  display: flex;
  gap: 0;
  padding: 12px 32px;
  background: transparent;
  justify-content: center;
}

.compare-dropdown-tabs .pill-container {
  display: flex;
  gap: 4px;
  padding: 4px;
  background: transparent;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  width: calc(100% - 40px);
  margin: 0 auto;
}

.compare-tab-pill {
  flex: 1 1;
  padding: 8px 20px;
  background: transparent;
  border: none;
  border-radius: 16px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 11px;
  font-weight: 500;
  font-family: 'NeoSans', sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  min-width: 120px;
}

.compare-tab-pill:hover {
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.9);
}

.compare-tab-pill.active {
  background: transparent;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  color: #fff;
}

.compare-dropdown-list {
  max-height: 300px;
  overflow-y: auto;
  padding: 8px 0;
}

.compare-dropdown-item {
  margin: 8px 12px;
  padding: 12px 16px;
  cursor: pointer;
  transition: all 0.2s ease;
  border-radius: 20px;
  background: rgba(51, 51, 51, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
}

.compare-dropdown-item:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.2);
}

.compare-item-name {
  color: #fff;
  font-size: 14px;
  font-family: 'NeoSans', sans-serif;
  flex: 1 1;
  padding-right: 16px;
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  line-height: 1.4;
}

.compare-item-price {
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  font-family: 'NeoSans', sans-serif;
  font-weight: 500;
  white-space: nowrap;
  flex-shrink: 0;
}

.compare-dropdown-empty {
  padding: 20px 16px;
  text-align: center;
  color: rgba(255, 255, 255, 0.5);
  font-size: 14px;
  font-family: 'NeoSans', sans-serif;
}

.compare-dropdown-list {
  scrollbar-width: none; /* Firefox */
}

.compare-dropdown-list::-webkit-scrollbar {
  width: 0px;
  background: transparent;
}

.compare-dropdown-list:hover::-webkit-scrollbar {
  width: 4px;
}

.compare-dropdown-list:hover::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
}

.compare-dropdown-list:hover::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 2px;
}

.compare-dropdown-list:hover::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* ===== TIMEFRAME PILLS STYLES ===== */
.timeframe-pills-container {
  display: flex;
  gap: 8px;
}

.timeframe-pill {
  padding: 8px 16px;
  background: rgba(51, 51, 51, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  font-weight: 500;
  font-family: 'NeoSans', sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 40px;
  text-align: center;
}

.timeframe-pill:hover {
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.9);
  border-color: rgba(255, 255, 255, 0.2);
}

.timeframe-pill.active {
  background: transparent;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  color: #fff;
}

.date-selector-pill {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  background: rgba(51, 51, 51, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  font-weight: 500;
  font-family: 'NeoSans', sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
}

.date-selector-pill:hover {
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.9);
  border-color: rgba(255, 255, 255, 0.2);
}

.date-selector-pill.active {
  background: transparent;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  color: #fff;
}

/* ===== EXPORT DROPDOWN POPUP STYLES ===== */
.export-dropdown-popup {
  position: absolute;
  top: calc(100% + 8px);
  left: -100%;
  background: rgba(51, 51, 51, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 24px;
  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3),
    2px 0 2px rgba(255, 255, 255, 0.3) !important;
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  border-top: 1px solid rgba(255, 255, 255, 0.01);
  border-bottom: 1px solid rgba(255, 255, 255, 0.01);
  color: #fff;
  font-family: 'NeoSans', sans-serif;
  z-index: 12000;
  max-height: 500px;
  overflow-y: auto;
  scrollbar-width: none; /* Firefox */
}

.export-dropdown-popup::-webkit-scrollbar {
  width: 0px;
  background: transparent;
}

.export-dropdown-popup:hover::-webkit-scrollbar {
  width: 4px;
}

.export-dropdown-popup:hover::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
}

.export-dropdown-popup:hover::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 2px;
}

.export-dropdown-popup:hover::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.3);
}

.export-popup-title {
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 20px 0;
  color: #fff;
}

.export-product-info {
  display: flex;
  align-items: center;
  gap: 12px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 20px;
}

.export-product-indicator {
  width: 8px;
  height: 8px;
  background: #10B981;
  border-radius: 50%;
  flex-shrink: 0;
}

.export-product-details {
  flex: 1 1;
}

.export-product-name {
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  margin-bottom: 4px;
}

.export-product-date {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
}

.export-product-price {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
}

.export-timeframes-and-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  gap: 20px;
}

.export-timeframes {
  display: flex;
  gap: 6px;
  flex-wrap: nowrap;
  flex-shrink: 0;
}

.export-timeframe-pill {
  padding: 6px 12px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 16px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  font-weight: 500;
  font-family: 'NeoSans', sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 35px;
  text-align: center;
}

.export-timeframe-pill:hover {
  background: rgba(255, 255, 255, 0.15);
  color: rgba(255, 255, 255, 0.9);
}

.export-timeframe-pill.active {
  background: rgba(255, 255, 255, 0.2);
  border-color: rgba(255, 255, 255, 0.3);
  color: #fff;
}

.export-controls-row {
  display: flex;
  gap: 12px;
  align-items: center;
  flex-shrink: 0;
}

.export-dropdown-container {
  position: relative;
}

.export-dropdown-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 16px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 12px;
  font-weight: 500;
  font-family: 'NeoSans', sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 80px;
}

.export-dropdown-btn:hover {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.3);
}

.export-dropdown-btn.currency-btn .currency-symbol {
  background: #F59E0B;
  color: #000;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 10px;
  font-weight: 600;
}

.export-dropdown-menu {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  background: rgba(51, 51, 51, 0.95);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  z-index: 1000;
  overflow: hidden;
}

.export-dropdown-item {
  padding: 8px 12px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
  cursor: pointer;
  transition: all 0.2s ease;
}

.export-dropdown-item:hover {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}

.export-sort-section {
  display: flex;
  justify-content: flex-start;
  margin-bottom: 20px;
}

.export-sort-container {
  display: flex;
  gap: 4px;
  padding: 4px;
  background: rgba(51, 51, 51, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
}

.export-sort-btn {
  padding: 6px 12px;
  background: transparent;
  border: none;
  border-radius: 16px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  font-weight: 500;
  font-family: 'NeoSans', sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 80px;
}

.export-sort-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.9);
}

.export-sort-btn.active {
  background: transparent;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  color: #fff;
}

.export-inclusion-section {
  margin-bottom: 20px;
}

.export-inclusion-title {
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  margin: 0 0 12px 0;
}

.export-inclusion-pills {
  display: flex;
  gap: 8px;
}

.export-inclusion-pill {
  padding: 6px 12px;
  background: rgba(255, 255, 255, 0.1);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 16px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  font-weight: 500;
  font-family: 'NeoSans', sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
}

.export-inclusion-pill:hover {
  background: rgba(255, 255, 255, 0.15);
  color: rgba(255, 255, 255, 0.9);
}

.export-inclusion-pill.active {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.2);
  color: #8B5CF6;
}

/* ===== FREQUENCY DROPDOWN ITEMS ===== */

.frequency-dropdown-item {
  width: 100%;
  text-align: left;
  padding: 8px 12px;
  font-size: 14px;
  background: rgba(51, 51, 51, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  /* border-radius: 20px; */
  color: #fff;
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: 'NeoSans', sans-serif;
}

.frequency-dropdown-item:hover {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(255, 255, 255, 0.2);
}

.frequency-dropdown-item.selected {
  background: rgba(255, 255, 255, 0.05);
  /* border-color: rgba(139, 92, 246, 0.4); */
  color: #fff;
}

.frequency-dropdown-item.selected:hover {
  background: rgba(255, 255, 255, 0.05);
  /* border-color: rgba(139, 92, 246, 0.5); */
}

/* ===== CHART SETTINGS BUTTONS ===== */
.chart-settings-container {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
}

.chart-settings-btn {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background: rgba(51, 51, 51, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  transition: all 0.2s ease;
  font-family: 'NeoSans', sans-serif;
}

.chart-settings-btn:hover {
  background: rgba(255, 255, 255, 0.1);
  border-color: rgba(255, 255, 255, 0.2);
  color: rgba(255, 255, 255, 0.9);
}

.chart-icon-btn {
  border-radius: 50%;
  color: #8B5CF6;
}

.chart-icon-image {
  width: 18px;
  height: 18px;
  object-fit: contain;
}

.plus-icon-btn {
  border-radius: 8px !important;
  position: relative;
  background: #fff !important;
  padding: 8px !important;
  width: 40px !important;
  height: 40px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}

.plus-icon-btn:hover {
  background: rgba(255, 255, 255, 0.9) !important;
}

.plus-icon-btn svg {
  color: #000 !important;
  stroke: #000 !important;
  stroke-width: 2.5 !important;
  width: 20px !important;
  height: 20px !important;
}

.chart-notification-badge {
  position: absolute;
  top: 2px;
  right: 2px;
  background: transparent;
  color: #8B5CF6;
  font-size: 8px;
  font-weight: 600;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #8B5CF6;
}

/* ===== FORECAST POPUP STYLES ===== */
.forecast-popup-overlay,
.chart-settings-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.2);
  z-index: 9999;
}

.forecast-popup {
  position: absolute;
  top: 0;
  left: calc(100% + 13px);
  background: rgba(51, 51, 51, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 24px;
  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3),
    2px 0 2px rgba(255, 255, 255, 0.3) !important;
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  border-top: 1px solid rgba(255, 255, 255, 0.01);
  border-bottom: 1px solid rgba(255, 255, 255, 0.01);
  width: 320px;
  color: #fff;
  font-family: 'NeoSans', sans-serif;
  z-index: 10000;
}

.forecast-popup-title {
  font-size: 18px;
  font-weight: 600;
  margin: 0 0 24px 0;
  color: #fff;
}

.forecast-section {
  margin-bottom: 24px;
}

.forecast-section-title {
  font-size: 14px;
  font-weight: 500;
  color: #fff;
  margin: 0 0 12px 0;
}

.forecast-projection-pills {
  display: flex;
  gap: 4px;
  padding: 4px;
  background: rgba(51, 51, 51, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
}

.forecast-projection-pill {
  flex: 1 1;
  padding: 8px 12px;
  background: transparent;
  border: none;
  border-radius: 16px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  font-weight: 500;
  font-family: 'NeoSans', sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;
}

.forecast-projection-pill:hover {
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.9);
}

.forecast-projection-pill.active {
  background: transparent;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  color: #8B5CF6;
}

.forecast-news-pills {
  display: flex;
  gap: 4px;
  padding: 4px;
  background: rgba(51, 51, 51, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 20px;
}

.forecast-news-pill {
  flex: 1 1;
  padding: 8px 12px;
  background: transparent;
  border: none;
  border-radius: 16px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  font-weight: 500;
  font-family: 'NeoSans', sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
  text-align: center;
}

.forecast-news-pill:hover {
  background: rgba(255, 255, 255, 0.1);
  color: rgba(255, 255, 255, 0.9);
}

.forecast-news-pill.active {
  background: transparent;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  color: #8B5CF6;
}

.forecast-textarea {
  width: 100%;
  min-height: 80px;
  padding: 12px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  color: #fff;
  font-size: 12px;
  font-family: 'NeoSans', sans-serif;
  resize: vertical;
  outline: none;
}

.forecast-textarea::placeholder {
  color: rgba(255, 255, 255, 0.5);
  font-style: italic;
}

.forecast-textarea:focus {
  border-color: rgba(255, 255, 255, 0.2);
  background: rgba(255, 255, 255, 0.08);
}

.forecast-actions {
  display: flex;
  gap: 12px;
  margin-top: 24px;
}

/* ===== Custom DatePicker Styles ===== */
.custom-datepicker-wrapper {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  background: transparent;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 20px;
  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3), 2px 0 2px rgba(255, 255, 255, 0.3);
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  border-top: 1px solid rgba(255, 255, 255, 0.01);
  border-bottom: 1px solid rgba(255, 255, 255, 0.01);
  min-width: 350px;
  z-index: 1000;
}

.custom-datepicker-field-container {
  margin-bottom: 16px;
  width: 100%;
  display: flex;
  flex-direction: column;
}

.custom-datepicker-field-container:last-of-type {
  margin-bottom: 20px;
}

.custom-datepicker-label {
  color: #9CA3AF;
  font-size: 12px;
  display: block;
  margin-bottom: 6px;
}

.custom-datepicker-input {
  width: 100% !important;
  padding: 10px 12px;
  background: transparent;
  border: 2px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  color: #D1D5DB;
  font-size: 14px;
  outline: none;
  cursor: pointer;
  box-sizing: border-box;
}

.custom-datepicker-input:focus {
  border-color: rgba(139, 92, 246, 0.5);
}

.custom-datepicker-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-end;
}

.datepicker-btn {
  padding: 8px 16px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  border: 1px solid;
  transition: all 0.2s ease;
}

.datepicker-btn-cancel {
  background: rgba(75, 85, 99, 0.3);
  border-color: rgba(156, 163, 175, 0.2);
  color: #9CA3AF;
}

.datepicker-btn-cancel:hover {
  background: rgba(75, 85, 99, 0.5);
}

.datepicker-btn-apply {
  background: rgba(139, 92, 246, 0.8);
  border-color: rgba(139, 92, 246, 0.5);
  color: #fff;
  font-weight: 500;
}

.datepicker-btn-apply:hover {
  background: rgba(139, 92, 246, 1);
}

.datepicker-btn-apply:disabled {
  background: rgba(75, 85, 99, 0.3);
  border-color: rgba(75, 85, 99, 0.3);
  color: #6B7280;
  cursor: not-allowed;
}

/* React DatePicker Calendar Styling */
.react-datepicker {
  background: rgba(30, 33, 44, 0.85) !important;
  backdrop-filter: blur(10px) !important;
  -webkit-backdrop-filter: blur(10px) !important;
  border-radius: 20px !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3), 2px 0 2px rgba(255, 255, 255, 0.3) !important;
  font-family: 'NeoSans', sans-serif !important;
  padding: 16px !important;
}

.react-datepicker__header {
  background: transparent !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
  padding: 12px 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 8px !important;
  top: -4px !important;
}

.react-datepicker__current-month,
.react-datepicker-time__header,
.react-datepicker-year-header {
  display: none !important;
}

.react-datepicker__day-name,
.react-datepicker__day,
.react-datepicker__time-name {
  color: #D1D5DB !important;
  width: 2rem !important;
  line-height: 2rem !important;
  margin: 0.2rem !important;
}

.react-datepicker__day--weekend {
  color: #EF4444 !important;
}

.react-datepicker__day:hover {
  background: rgba(139, 92, 246, 0.3) !important;
  border-radius: 8px !important;
}

.react-datepicker__day--selected,
.react-datepicker__day--in-selecting-range,
.react-datepicker__day--in-range {
  background: rgba(139, 92, 246, 0.6) !important;
  color: #fff !important;
  border-radius: 8px !important;
}

.react-datepicker__day--keyboard-selected {
  background: rgba(139, 92, 246, 0.4) !important;
  border-radius: 8px !important;
}

.react-datepicker__day--disabled {
  color: rgba(156, 163, 175, 0.3) !important;
  cursor: not-allowed !important;
}

.react-datepicker__navigation {
  top: 30px !important;
}

.react-datepicker__navigation-icon::before {
  border-color: #D1D5DB !important;
}

.react-datepicker__navigation:hover *::before {
  border-color: #fff !important;
}

.react-datepicker__triangle {
  display: none !important;
}

.react-datepicker__month {
  margin: 0.8rem !important;
  padding-top: 0.4rem !important;
}

/* Year and Month Dropdown Selectors */
.react-datepicker__year-dropdown-container,
.react-datepicker__month-dropdown-container {
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin: 0 2px !important;
}

.react-datepicker__year-dropdown-container select,
.react-datepicker__month-dropdown-container select,
.react-datepicker__year-dropdown,
.react-datepicker__month-dropdown,
select.react-datepicker__month-select,
select.react-datepicker__year-select {
  background: rgba(60, 66, 81, 0.8) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  border-radius: 6px !important;
  color: #D1D5DB !important;
  padding: 10px 8px !important;
  font-size: 13px !important;
  font-family: 'NeoSans', sans-serif !important;
  cursor: pointer !important;
  transition: all 0.2s ease !important;
  appearance: none !important;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) !important;
  background-repeat: no-repeat !important;
  background-position: right 8px center !important;
  padding-right: 28px !important;
}

.react-datepicker__year-dropdown-container select:hover,
.react-datepicker__month-dropdown-container select:hover,
.react-datepicker__year-dropdown:hover,
.react-datepicker__month-dropdown:hover,
select.react-datepicker__month-select:hover,
select.react-datepicker__year-select:hover {
  background-color: rgba(75, 85, 99, 0.9) !important;
  border-color: rgba(139, 92, 246, 0.5) !important;
}

.react-datepicker__year-dropdown-container select:focus,
.react-datepicker__month-dropdown-container select:focus,
.react-datepicker__year-dropdown:focus,
.react-datepicker__month-dropdown:focus,
select.react-datepicker__month-select:focus,
select.react-datepicker__year-select:focus {
  outline: none !important;
  background-color: rgba(75, 85, 99, 1) !important;
  border-color: rgba(139, 92, 246, 0.7) !important;
  box-shadow: 0 0 0 2px rgba(139, 92, 246, 0.25) !important;
}

.react-datepicker__year-dropdown-container select option,
.react-datepicker__month-dropdown-container select option,
select.react-datepicker__month-select option,
select.react-datepicker__year-select option {
  background: rgba(30, 33, 44, 0.95) !important;
  color: #D1D5DB !important;
  padding: 8px !important;
}

.forecast-btn {
  flex: 1 1;
  padding: 12px 20px;
  border: none;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 600;
  font-family: 'NeoSans', sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.forecast-btn-cancel {
  background: rgba(239, 68, 68, 0.2);
  border: 1px solid rgba(239, 68, 68, 0.3);
  color: #EF4444;
}

.forecast-btn-cancel:hover {
  background: rgba(239, 68, 68, 0.3);
  border-color: rgba(239, 68, 68, 0.5);
}

.forecast-btn-apply {
  background: rgba(139, 92, 246, 0.2);
  border: 1px solid rgba(139, 92, 246, 0.3);
  color: #8B5CF6;
}

.forecast-btn-apply:hover {
  background: rgba(139, 92, 246, 0.3);
  border-color: rgba(139, 92, 246, 0.5);
}

/* ===== NEWS TAB CONTENT STYLES ===== */
#insights {
  height: 70vh;
  overflow-y: auto;
  scrollbar-width: none; /* Firefox */
}

#insights::-webkit-scrollbar {
  width: 0px;
  background: transparent;
}

#insights:hover::-webkit-scrollbar {
  width: 4px;
}

#insights:hover::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
}

#insights:hover::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 2px;
}

#insights:hover::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* ===== CHART SETTINGS POPUP STYLES ===== */
.chart-settings-popup {
  position: absolute;
  top: 60px;
  left: 0;
  background: rgba(51, 51, 51, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 24px;
  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3),
    2px 0 2px rgba(255, 255, 255, 0.3);
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  border-top: 1px solid rgba(255, 255, 255, 0.01);
  border-bottom: 1px solid rgba(255, 255, 255, 0.01);
  width: 850px;
  color: #fff;
  font-family: 'NeoSans', sans-serif;
  z-index: 10000;
}

.chart-settings-title {
  font-size: 18px;
  font-weight: 700;
  letter-spacing: 2px;
  margin-bottom: 24px;
  color: #fff;
}

.chart-settings-header {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 16px;
  padding: 12px 16px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
  text-transform: uppercase;
  letter-spacing: 1px;
}

.chart-settings-items {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 24px;
}

.chart-settings-item {
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 16px;
  align-items: center;
  padding: 16px;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  transition: all 0.2s ease;
}

.chart-settings-item:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.15);
}

.chart-settings-item-name {
  display: flex;
  align-items: center;
  gap: 12px;
}

/* Custom color picker */
.cs-color-picker-wrap {
  position: relative;
  flex-shrink: 0;
}

.cs-color-swatch {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, 0.25);
  cursor: pointer;
  padding: 0;
  transition: border-color 0.2s, transform 0.15s;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);
}

.cs-color-swatch:hover {
  border-color: rgba(255, 255, 255, 0.55);
  transform: scale(1.08);
}

.cs-color-popover {
  position: absolute;
  top: calc(100% + 10px);
  left: 0;
  z-index: 10100;
  width: 196px;
  padding: 14px;
  border-radius: 16px;
  background: rgba(28, 30, 44, 0.92);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.55), 0 0 0 0.5px rgba(255,255,255,0.06) inset;
}

.cs-color-presets {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 8px;
  margin-bottom: 12px;
}

.cs-color-preset {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 2px solid transparent;
  cursor: pointer;
  padding: 0;
  transition: transform 0.15s, border-color 0.15s;
  box-shadow: 0 2px 6px rgba(0,0,0,0.3);
}

.cs-color-preset:hover {
  transform: scale(1.15);
  border-color: rgba(255, 255, 255, 0.5);
}

.cs-color-preset.active {
  border-color: #fff;
  transform: scale(1.1);
}

.cs-color-hex-row {
  display: flex;
  align-items: center;
  gap: 8px;
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  padding: 6px 10px;
}

.cs-color-hex-preview {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  flex-shrink: 0;
  border: 1px solid rgba(255,255,255,0.2);
}

.cs-color-hex-input {
  flex: 1 1;
  background: transparent;
  border: none;
  outline: none;
  color: #fff;
  font-size: 13px;
  font-family: 'NeoSans', monospace;
  letter-spacing: 1px;
  min-width: 0;
}

.chart-settings-item-price {
  font-size: 14px;
  font-weight: 500;
}

.chart-settings-dropdown {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  background: rgba(51, 51, 51, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 20px;
  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3),
    2px 0 2px rgba(255, 255, 255, 0.3);
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  border-top: 1px solid rgba(255, 255, 255, 0.01);
  border-bottom: 1px solid rgba(255, 255, 255, 0.01);
  color: #fff;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.chart-settings-dropdown:hover {
  background: rgba(75, 85, 99, 0.4);
  border-left: 1px solid rgba(255, 255, 255, 0.2);
  border-right: 1px solid rgba(255, 255, 255, 0.2);
}

.currency-icon {
  font-size: 14px;
}

.dropdown-arrow {
  font-size: 10px;
  opacity: 0.6;
}

.chart-settings-dropdown-menu {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  background: rgba(51, 51, 51, 0.594);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.063);
  border-radius: 8px;
  padding: 4px;
  min-width: 180px;
  max-height: 200px;
  overflow-y: auto;
  z-index: 10001;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.188);
}

.chart-settings-dropdown-menu::-webkit-scrollbar {
  width: 4px;
}

.chart-settings-dropdown-menu::-webkit-scrollbar-track {
  background: transparent;
}

.chart-settings-dropdown-menu::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 2px;
}

.chart-settings-dropdown-menu::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.3);
}

.chart-settings-dropdown-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  color: #fff;
  font-size: 13px;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.chart-settings-dropdown-item:hover {
  background: rgba(255, 255, 255, 0.1);
}

.chart-settings-dropdown:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.chart-settings-dropdown-item.active {
  background: rgba(255, 255, 255, 0.12);
}

.chart-settings-dropdown-group {
  padding: 6px 12px 2px;
  font-size: 11px;
  color: #9CA3AF;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  margin-top: 4px;
}

.chart-settings-conversion-hint {
  margin-top: 4px;
  font-size: 11px;
  line-height: 1.3;
  color: #9CA3AF;
  max-width: 160px;
}

/* Hinweis zur Umrechnung unter dem Chart */
.chart-conversion-note {
  display: flex;
  flex-wrap: wrap;
  gap: 4px 12px;
  margin-top: 8px;
  font-size: 11px;
  line-height: 1.4;
  color: #9CA3AF;
}

.chart-conversion-note-item[title] {
  cursor: help;
  -webkit-text-decoration: underline dotted rgba(156, 163, 175, 0.6);
          text-decoration: underline dotted rgba(156, 163, 175, 0.6);
  text-underline-offset: 2px;
}

.chart-conversion-note-warning {
  color: #F59E0B;
}

.chart-settings-tabs {
  display: inline-flex;
  gap: 0;
  padding: 0;
  margin-bottom: 24px;
  background: rgba(51, 51, 51, 0.2);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 30px;
  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3),
    2px 0 2px rgba(255, 255, 255, 0.3) !important;
  border-left: 1px solid rgba(255, 255, 255, 0.1);
  border-right: 1px solid rgba(255, 255, 255, 0.1);
  border-top: 1px solid rgba(255, 255, 255, 0.01);
  border-bottom: 1px solid rgba(255, 255, 255, 0.01);
  align-items: center;
  overflow: hidden;
}

.chart-settings-tab {
  padding: 4px 18px;
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
  border-radius: 30px;
  color: rgba(255, 255, 255, 0.6);
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s ease;
  flex: 1 1;
  min-width: fit-content;
}

.chart-settings-tab:hover {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
}

.chart-settings-tab.active {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border-radius: 30px;
  box-shadow: -1px 0 1px rgba(255, 255, 255, 0.15),
    1px 0 1px rgba(255, 255, 255, 0.15) !important;
  border-left: 0.5px solid rgba(255, 255, 255, 0.1) !important;
  border-right: 0.5px solid rgba(255, 255, 255, 0.1) !important;
  border-top: 0.5px solid rgba(255, 255, 255, 0.01) !important;
  border-bottom: 0.5px solid rgba(255, 255, 255, 0.01) !important;
  color: #fff;
}

.chart-settings-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.chart-settings-btn {
  padding: 10px 32px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 1px;
  cursor: pointer;
  transition: all 0.2s ease;
}

.chart-settings-btn-cancel {
  background: #dc2626;
  border: 1px solid #dc2626;
  color: #fff;
}

.chart-settings-btn-cancel:hover {
  background: #b91c1c;
  border-color: #b91c1c;
}

.chart-settings-btn-save {
  background: rgba(139, 92, 246, 0.2);
  border: 1px solid rgba(139, 92, 246, 0.5);
  color: #a78bfa;
}

.chart-settings-btn-save:hover {
  background: rgba(139, 92, 246, 0.3);
  border-color: rgba(139, 92, 246, 0.7);
}

/* ===== RESPONSIVE FONT SIZES ===== */
/* Tablet adjustments (1025px - 1440px) */
@media (max-width: 1440px) {
  :root {
    --fs-page-title: 28px;
  }
}

/* Tablet breakpoint (768px - 1025px) */
@media (max-width: 1025px) {
  :root {
    --fs-page-title: 24px;
    --fs-section-header: 16px;
    --fs-chart-title: 18px;
    --fs-chart-label: 14px;
    --fs-tab-button: 14px;
  }

  /* Adjust button font sizes for tablet */
  .chart-btn {
    font-size: 13px;
    padding: 7px 12px;
  }

  .btn-transparent {
    font-size: 13px;
    padding: 7px 10px;
  }
}

/* Mobile breakpoint (max-width: 768px) */
@media (max-width: 768px) {
  :root {
    --fs-page-title: 20px;
    --fs-section-header: 16px;
    --fs-chart-title: 16px;
    --fs-chart-label: 12px;
    --fs-chart-text: 13px;
    --fs-chart-small: 11px;
    --fs-chart-tiny: 10px;
    --fs-tab-button: 12px;
  }

  /* Mobile button adjustments */
  .chart-btn {
    font-size: 12px;
    padding: 6px 10px;
  }

  .btn-transparent {
    font-size: 12px;
    padding: 6px 8px;
  }

  /* Smaller padding for glass cards on mobile */
  .glass-card-ui {
    padding: 12px;
    border-radius: 16px;
  }
}

/* Small mobile breakpoint (max-width: 600px) */
@media (max-width: 600px) {
  :root {
    --fs-page-title: 18px;
    --fs-chart-title: 15px;
  }

  .glass-card-ui {
    padding: 10px;
  }
}

/* ===== SUPPLIER TAB STYLES ===== */

/* ===== Availability & Need Vertical Override ===== */
.availability-need-layout {
  display: flex !important;
  flex-direction: column !important;
  gap: 20px !important;
  width: 100%;
}

.availability-section,
.need-section {
  width: 100% !important;
  min-height: 420px;
}

@media (max-width: 1024px) {
  .availability-need-layout {
    gap: 16px !important;
  }

  .availability-section,
  .need-section {
    min-height: 340px;
  }
}

/* Remove browser focus outline on Recharts SVG and wrappers */
.recharts-wrapper,
.recharts-wrapper:focus,
.recharts-wrapper:focus-visible,
.recharts-wrapper:focus-within,
.recharts-wrapper svg,
.recharts-wrapper svg:focus,
.recharts-wrapper svg:focus-visible,
.recharts-surface,
.recharts-surface:focus,
.recharts-surface:focus-visible,
.recharts-wrapper *:focus,
.recharts-wrapper *:focus-visible {
  outline: none !important;
  outline-style: none !important;
  outline-width: 0 !important;
  outline-color: transparent !important;
  box-shadow: none !important;
  -webkit-box-shadow: none !important;
}

.recharts-wrapper {
  -webkit-tap-highlight-color: transparent;
}
`, "",{"version":3,"sources":["webpack://./src/css/chart-main.css"],"names":[],"mappings":"AAAA,6BAA6B;;AAE7B,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;;EAEhB,uCAAuC;EACvC,qBAAqB;EACrB,yBAAyB;EACzB,sBAAsB;EACtB,sBAAsB;EACtB,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA,iCAAiC;AACjC;EACE,sBAAsB;EACtB;;8DAEyD;EACzD,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB;;8DAE8D;EAC9D,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb;iDAC+C;EAC/C,+CAA+C,EAAE,wBAAwB;EACzE,gDAAgD,EAAE,wBAAwB;EAC1E,+CAA+C,EAAE,8BAA8B;EAC/E,kDAAkD,EAAE,iCAAiC;AACvF;;AAEA,0CAA0C;AAC1C,kEAAkE;AAClE;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,gCAAgC;EAChC,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,+BAA+B;EAC/B,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA,2CAA2C;AAC3C,sDAAsD;AACtD;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;;EAEnB,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,qCAAqC;AACrC;EACE,iCAAiC;EACjC,sCAAsC;EACtC,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc,EAAE,gCAAgC;AAClD;;AAEA,6CAA6C;AAC7C;EACE,SAAO;EACP,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,uBAAuB;AACzB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,MAAM;EACN,UAAU;EACV,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB;iDAC+C;EAC/C,+CAA+C;EAC/C,gDAAgD;EAChD,+CAA+C;EAC/C,kDAAkD;EAClD,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gCAAgC;EAChC,wCAAwC;EACxC,2BAA2B;EAC3B,SAAO;AACT;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,gCAAgC;EAChC,wCAAwC;EACxC,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;EACvC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB;kDACgD;EAChD,8DAA8D;EAC9D,+DAA+D;EAC/D,8DAA8D;EAC9D,iEAAiE;EACjE,WAAW;AACb;;AAEA,0DAA0D;AAC1D;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB;iDAC+C;EAC/C,+CAA+C;EAC/C,gDAAgD;EAChD,+CAA+C;EAC/C,kDAAkD;AACpD;;AAEA;EACE,iCAAiC;EACjC,+CAA+C;EAC/C,gDAAgD;AAClD;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,kBAAkB;EAClB,iBAAiB;EACjB,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,cAAc;EACd,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,SAAS;EACT,eAAe;AACjB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;EACvC,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,UAAU;EACV,YAAY;EACZ,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,gCAAgC;EAChC,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iBAAiB,EAAE,wDAAwD;AAC7E;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,OAAO;EACP,OAAO;EACP,WAAW;EACX,UAAU;EACV;;;;+BAI6B;EAC7B,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,+CAA+C;EAC/C,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB;qDACmD;EACnD,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;AACA;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,4BAA4B;EAC5B;;iDAE+C;AACjD;;AAEA;EACE,qCAAqC;EACrC;;gDAE8C;EAC9C,2BAA2B;AAC7B;;;AAGA;EACE,cAAc;AAChB;;AAEA,sEAAsE;AACtE;;EAEE,2BAA2B;EAC3B,uBAAuB;EACvB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,wBAAwB;EACxB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;EACE,gDAAgD;EAChD,sCAAsC;EACtC,qDAAqD;EACrD,oDAAoD;EACpD,wBAAwB;EACxB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,wBAAwB;EACxB,QAAQ;EACR,SAAS;EACT,kCAAkC;EAClC,mCAAmC;EACnC,iDAAiD;AACnD;;AAEA;EACE;IACE,UAAU;IACV,4CAA4C;EAC9C;EACA;IACE,UAAU;IACV,yCAAyC;EAC3C;AACF;;AAEA,+BAA+B;AAC/B;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,uBAAuB;EACvB,UAAU;EACV,iBAAiB;AACnB;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,yBAAyB;EACzB,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,yBAAyB;EACzB,oCAAoC;EACpC,qBAAqB;EACrB,6BAA6B;EAC7B,yCAAyC;EACzC,mBAAmB;EACnB,YAAY;EACZ,WAAW;EACX,yBAAyB;EACzB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,oCAAoC;EACpC,mCAAmC;EACnC,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,YAAY;EACZ,mCAAmC;EACnC,2BAA2B;EAC3B,mCAAmC;EACnC,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,UAAU;EACV,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mCAAmC;EACnC,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB;kDACgD;EAChD,gDAAgD;EAChD,iDAAiD;EACjD,gDAAgD;EAChD,mDAAmD;EACnD,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,gDAAgD;EAChD,iDAAiD;EACjD,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,gDAAgD;EAChD,iDAAiD;EACjD,gDAAgD;EAChD,mDAAmD;EACnD,WAAW;AACb;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,MAAM;EACN,UAAU;EACV,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB;kDACgD;EAChD,gDAAgD;EAChD,iDAAiD;EACjD,gDAAgD;EAChD,mDAAmD;EACnD,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;EAC3B,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,QAAQ;EACR,WAAW;EACX,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,2BAA2B;EAC3B,2BAA2B;AAC7B;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;EAChC,0BAA0B;EAC1B,kCAAkC;EAClC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mHAAmH;EACnH,0BAA0B;EAC1B,qDAAqD;AACvD;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,2BAA2B;EAC7B;EACA;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA,qCAAqC;AACrC;EACE,uCAAuC;EACvC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB;iDAC+C;EAC/C,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA,8DAA8D;AAC9D;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,iCAAiC;EACjC,0CAA0C;EAC1C,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,iDAAiD;EACjD,gBAAgB;EAChB,4BAA4B;EAC5B,aAAa;EACb,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,sEAAsE;EACtE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,UAAU;AACZ;;AAEA,0CAA0C;AAC1C;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,qCAAqC;AACrC;EACE,eAAe;EACf,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,SAAS;EACT,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY,EAAE,wCAAwC;EACtD,cAAc;EACd,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb;0CACwC;EACxC,gBAAgB,EAAE,6BAA6B;AACjD;;AAEA;EACE,aAAa;EACb,YAAY,EAAE,wCAAwC;EACtD,cAAc;EACd,gBAAgB,EAAE,6BAA6B;EAC/C,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,aAAa;IACb,cAAc;IACd,aAAa;EACf;;EAEA;IACE,aAAa;IACb,cAAc;EAChB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;;IAEE,cAAc;IACd,eAAe;IACf,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,yCAAyC;AACzC;EACE;;;;;;;uDAOqD;EACrD,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,0BAA0B;EAC1B,wBAAwB;EACxB,4DAA4D;EAC5D,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,yBAAyB;EACzB,wBAAwB;EACxB,0BAA0B;EAC1B,6DAA6D;EAC7D,6BAA6B;EAC7B,qCAAqC;AACvC;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;AAC7B;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,YAAY;EACZ,iCAAiC;EACjC,2BAA2B;EAC3B,mFAAmF;EACnF,mCAAmC;EACnC,0CAA0C;EAC1C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,2BAA2B;EAC3B;0CACwC;AAC1C;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,iBAAiB;IACjB,aAAa;EACf;AACF;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;AACX;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,8CAA8C;AAChD;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;AACX;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,oBAAoB;EACpB,WAAW;AACb;;AAEA;;EAEE,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb;0CACwC;EACxC,iBAAiB;EACjB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;;EAEA;;IAEE,iBAAiB;IACjB,aAAa;EACf;AACF;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;;IAEE,iBAAiB;IACjB,aAAa;EACf;AACF;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,wBAAwB;EACxB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,SAAS;EACT,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,WAAW;AACb;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,eAAe;EACf,2CAA2C;EAC3C,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,0BAA0B;EAC1B,2CAA2C;EAC3C,WAAW;AACb;;AAEA;EACE;IACE,0BAA0B;IAC1B,SAAS;EACX;AACF;;AAEA,+BAA+B;AAC/B;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,0CAA0C;EAC1C,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,+BAA+B;EAC/B,yCAAyC;AAC3C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,2BAA2B;EAC7B;;EAEA;IACE,WAAW;IACX,2BAA2B;EAC7B;AACF;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS,EAAE,oDAAoD;AACjE;;AAEA,sBAAsB;AACtB;EACE;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;AACF;;AAEA,8BAA8B;AAC9B;EACE;IACE,gCAAgC;IAChC,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,gBAAgB;IAChB,QAAQ,EAAE,4BAA4B;EACxC;AACF;;AAEA,0BAA0B;AAC1B;EACE;IACE,gCAAgC;IAChC,SAAS;EACX;;EAEA;IACE,YAAY;EACd;AACF;;AAEA,gCAAgC;AAChC;EACE;IACE,aAAa;EACf;;EAEA;IACE,SAAS;EACX;;EAEA,6DAA6D;EAC7D;IACE,gBAAgB;IAChB,iCAAiC;IACjC,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,+CAA+C;AAC/C,kDAAkD;AAClD;EACE,cAAc;AAChB;;AAEA,kCAAkC;AAClC;EACE,aAAa;EACb,kCAAkC;EAClC,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA,6CAA6C;AAC7C;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,qCAAqC;AACrC;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA,4CAA4C;AAC5C;EACE,aAAa;EACb,uCAAuC;EACvC,SAAS;EACT,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA,8BAA8B;AAC9B;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,gDAAgD;AAChD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA,wBAAwB;AACxB;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,qCAAqC;AACrC;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,yBAAyB;AACzB;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,+BAA+B;AACjC;;AAEA,8CAA8C;AAC9C;EACE,gBAAgB;EAChB,iBAAiB;EACjB,8CAA8C;EAC9C,6CAA6C;AAC/C;;AAEA,8BAA8B;AAC9B;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,8BAA8B;EAC9B,MAAM;EACN,mBAAmB;EACnB,0CAA0C;EAC1C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA,uCAAuC;AACvC;EACE,gDAAgD;AAClD;;AAEA,2CAA2C;AAC3C;EACE,iDAAiD;AACnD;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA,yBAAyB;AACzB;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,mBAAmB;EACnB,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,wCAAwC;AACxC;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,yBAAyB;AAC3B;;AAEA;;EAEE,sCAAsC;EACtC,iCAAiC;AACnC;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,SAAS;EACT,2BAA2B;EAC3B,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB;iDAC+C;EAC/C,+CAA+C;EAC/C,gDAAgD;EAChD,+CAA+C;EAC/C,kDAAkD;EAClD,aAAa;EACb,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,MAAM;EACN,kBAAkB;EAClB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,uBAAuB;EACvB,0CAA0C;EAC1C,mBAAmB;EACnB,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;EACzB,mBAAmB;EACnB,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kCAAkC;EAClC,SAAO;EACP,mBAAmB;EACnB,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,+BAA+B;EAC/B,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;EAC/B,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,qBAAqB,EAAE,YAAY;AACrC;;AAEA;EACE,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;EAC/B,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,yCAAyC;EACzC,WAAW;AACb;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb;iDAC+C;EAC/C,+CAA+C;EAC/C,gDAAgD;EAChD,+CAA+C;EAC/C,kDAAkD;EAClD,WAAW;EACX,kCAAkC;EAClC,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB,EAAE,YAAY;AACrC;;AAEA;EACE,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,yBAAyB;EACzB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,+BAA+B;EAC/B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,yCAAyC;EACzC,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,oCAAoC;EACpC,0CAA0C;EAC1C,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,+BAA+B;AACjC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,cAAc;AAChB;;AAEA,yCAAyC;;AAEzC;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA,uCAAuC;AACvC;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;EACtC,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,2BAA2B;EAC3B,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,uBAAuB;EACvB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA,sCAAsC;AACtC;;EAEE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,uBAAuB;EACvB,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb;iDAC+C;EAC/C,+CAA+C;EAC/C,gDAAgD;EAChD,+CAA+C;EAC/C,kDAAkD;EAClD,YAAY;EACZ,WAAW;EACX,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,kCAAkC;EAClC,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,sCAAsC;EACtC,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,eAAe;EACf,uBAAuB;EACvB,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb,mFAAmF;EACnF,+CAA+C;EAC/C,gDAAgD;EAChD,+CAA+C;EAC/C,kDAAkD;EAClD,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,uBAAuB;EACvB,0CAA0C;EAC1C,yCAAyC;EACzC,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,cAAc;EACd,mBAAmB;AACrB;;AAEA,sCAAsC;AACtC;EACE,6CAA6C;EAC7C,sCAAsC;EACtC,8CAA8C;EAC9C,8BAA8B;EAC9B,qDAAqD;EACrD,8FAA8F;EAC9F,6CAA6C;EAC7C,wBAAwB;AAC1B;;AAEA;EACE,kCAAkC;EAClC,4DAA4D;EAC5D,0BAA0B;EAC1B,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;;;EAGE,wBAAwB;AAC1B;;AAEA;;;EAGE,yBAAyB;EACzB,sBAAsB;EACtB,4BAA4B;EAC5B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,8CAA8C;EAC9C,6BAA6B;AAC/B;;AAEA;;;EAGE,8CAA8C;EAC9C,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,8CAA8C;EAC9C,6BAA6B;AAC/B;;AAEA;EACE,0CAA0C;EAC1C,8BAA8B;AAChC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,yBAAyB;EACzB,8BAA8B;AAChC;;AAEA,sCAAsC;AACtC;;EAEE,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,wBAAwB;AAC1B;;AAEA;;;;;;EAME,4CAA4C;EAC5C,qDAAqD;EACrD,6BAA6B;EAC7B,yBAAyB;EACzB,4BAA4B;EAC5B,0BAA0B;EAC1B,6CAA6C;EAC7C,0BAA0B;EAC1B,oCAAoC;EACpC,2BAA2B;EAC3B,oEAAqM;EACrM,uCAAuC;EACvC,gDAAgD;EAChD,8BAA8B;AAChC;;AAEA;;;;;;EAME,kDAAkD;EAClD,gDAAgD;AAClD;;AAEA;;;;;;EAME,wBAAwB;EACxB,gDAAgD;EAChD,gDAAgD;EAChD,yDAAyD;AAC3D;;AAEA;;;;EAIE,6CAA6C;EAC7C,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,eAAe;EACf,yBAAyB;EACzB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,kCAAkC;EAClC,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,oCAAoC;AACtC;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA,wCAAwC;AACxC;EACE,YAAY;EACZ,gBAAgB;EAChB,qBAAqB,EAAE,YAAY;AACrC;;AAEA;EACE,UAAU;EACV,uBAAuB;AACzB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA,4CAA4C;AAC5C;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,aAAa;EACb;sCACoC;EACpC,+CAA+C;EAC/C,gDAAgD;EAChD,+CAA+C;EAC/C,kDAAkD;EAClD,YAAY;EACZ,WAAW;EACX,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sCAAsC;EACtC,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,2CAA2C;EAC3C,eAAe;EACf,UAAU;EACV,8CAA8C;EAC9C,yCAAyC;AAC3C;;AAEA;EACE,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,OAAO;EACP,cAAc;EACd,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;EACnC,2CAA2C;EAC3C,qFAAqF;AACvF;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,UAAU;EACV,+CAA+C;EAC/C,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,qCAAqC;EACrC,0CAA0C;EAC1C,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,WAAW;EACX,eAAe;EACf,iCAAiC;EACjC,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB;sCACoC;EACpC,+CAA+C;EAC/C,gDAAgD;EAChD,+CAA+C;EAC/C,kDAAkD;EAClD,WAAW;EACX,eAAe;EACf,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,+CAA+C;EAC/C,gDAAgD;AAClD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,mCAAmC;EACnC,2BAA2B;EAC3B,mCAAmC;EACnC,4CAA4C;EAC5C,kBAAkB;EAClB,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,2CAA2C;AAC7C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,+CAA+C;EAC/C,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,eAAe;EACf,aAAa;EACb,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,kEAA0D;UAA1D,0DAA0D;EAC1D,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,MAAM;EACN,UAAU;EACV,mBAAmB;EACnB,iCAAiC;EACjC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB;iDAC+C;EAC/C,+CAA+C;EAC/C,gDAAgD;EAChD,+CAA+C;EAC/C,kDAAkD;EAClD,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kCAAkC;EAClC,uBAAuB;EACvB,2BAA2B;EAC3B,gCAAgC;EAChC,wCAAwC;EACxC,mBAAmB;EACnB,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,SAAO;EACP,sBAAsB;AACxB;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,2BAA2B;EAC3B,gCAAgC;EAChC,wCAAwC;AAC1C;;AAEA;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB;kDACgD;EAChD,4DAA4D;EAC5D,6DAA6D;EAC7D,4DAA4D;EAC5D,+DAA+D;EAC/D,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,qCAAqC;AACvC;;AAEA,sCAAsC;AACtC,yCAAyC;AACzC;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA,uCAAuC;AACvC;EACE;IACE,qBAAqB;IACrB,yBAAyB;IACzB,sBAAsB;IACtB,sBAAsB;IACtB,qBAAqB;EACvB;;EAEA,wCAAwC;EACxC;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;AACF;;AAEA,yCAAyC;AACzC;EACE;IACE,qBAAqB;IACrB,yBAAyB;IACzB,sBAAsB;IACtB,sBAAsB;IACtB,qBAAqB;IACrB,sBAAsB;IACtB,qBAAqB;IACrB,qBAAqB;EACvB;;EAEA,8BAA8B;EAC9B;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA,8CAA8C;EAC9C;IACE,aAAa;IACb,mBAAmB;EACrB;AACF;;AAEA,+CAA+C;AAC/C;EACE;IACE,qBAAqB;IACrB,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA,oCAAoC;;AAEpC,sDAAsD;AACtD;EACE,wBAAwB;EACxB,iCAAiC;EACjC,oBAAoB;EACpB,WAAW;AACb;;AAEA;;EAEE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE;IACE,oBAAoB;EACtB;;EAEA;;IAEE,iBAAiB;EACnB;AACF;;AAEA,8DAA8D;AAC9D;;;;;;;;;;;;EAYE,wBAAwB;EACxB,8BAA8B;EAC9B,2BAA2B;EAC3B,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,wCAAwC;AAC1C","sourcesContent":["/* ===== CHART LAYOUT ===== */\n\n/* ===== Base Variables ===== */\n:root {\n  --white: #ffffff;\n  --gray-33: #333333;\n  --primary-74: #7479ff;\n  --purple: #9b51e0;\n  --green: #228b22;\n\n  /* Font Size Variables - Standardized */\n  --fs-page-title: 30px;\n  --fs-section-header: 18px;\n  --fs-chart-title: 20px;\n  --fs-chart-label: 14px;\n  --fs-chart-text: 14px;\n  --fs-chart-small: 12px;\n  --fs-chart-tiny: 11px;\n  --fs-tab-button: 14px;\n}\n\n/* ===== Font Definitions ===== */\n@font-face {\n  font-family: \"NeoSans\";\n  src: url(\"../assets/neosans/NeoSans.woff2\") format(\"woff2\"),\n    url(\"../assets/neosans/NeoSans.woff\") format(\"woff\"),\n    url(\"../assets/neosans/NeoSans.ttf\") format(\"truetype\");\n  font-weight: normal;\n  font-style: normal;\n}\n\n@font-face {\n  font-family: \"NeoSans\";\n  src: url(\"../assets/neosans/NeoSans-Bold.woff2\") format(\"woff2\"),\n    url(\"../assets/neosans/NeoSans-Bold.woff\") format(\"woff\"),\n    url(\"../assets/neosans/NeoSans-Bold.ttf\") format(\"truetype\");\n  font-weight: bold;\n  font-style: normal;\n}\n\n/* ===== Utility Classes ===== */\n.glass-card-ui {\n  background: rgba(51, 51, 51, 0.2);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-radius: 20px;\n  padding: 16px;\n  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3),\n    2px 0 2px rgba(255, 255, 255, 0.3) !important;\n  border-left: 1px solid rgba(255, 255, 255, 0.1); /* Side borders normal */\n  border-right: 1px solid rgba(255, 255, 255, 0.1); /* Side borders normal */\n  border-top: 1px solid rgba(255, 255, 255, 0.01); /* Top much more transparent */\n  border-bottom: 1px solid rgba(255, 255, 255, 0.01); /* Bottom much more transparent */\n}\n\n/* ===== Font Size Utility Classes ===== */\n/* Use these classes throughout chart components for consistency */\n.chart-page-title {\n  font-size: var(--fs-page-title);\n  font-weight: 600;\n  color: var(--white);\n}\n\n.chart-section-header {\n  font-size: var(--fs-section-header);\n  font-weight: 500;\n  color: var(--white);\n}\n\n.chart-title {\n  font-size: var(--fs-chart-title);\n  font-weight: 600;\n  color: var(--white);\n}\n\n.chart-subtitle {\n  font-size: var(--fs-section-header);\n  font-weight: 400;\n  color: rgba(255, 255, 255, 0.8);\n}\n\n.chart-label {\n  font-size: var(--fs-chart-label);\n  font-weight: 400;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.chart-text {\n  font-size: var(--fs-chart-text);\n  font-weight: 400;\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.chart-small {\n  font-size: var(--fs-chart-small);\n  font-weight: 400;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.chart-tiny {\n  font-size: var(--fs-chart-tiny);\n  font-weight: 400;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n/* ===== Transparent Button Styling ===== */\n/* Base transparent button with glassmorphism effect */\n.btn-transparent {\n  background: rgba(51, 51, 51, 0.3);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  padding: 8px 12px;\n  color: #d1d5db;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 400;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n\n  /* Flex layout for icon + text alignment */\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Transparent button hover effects */\n.btn-transparent:hover {\n  background: rgba(75, 85, 99, 0.4);\n  border-color: rgba(255, 255, 255, 0.2);\n  color: #f3f4f6;\n}\n\n/* Transparent button disabled state */\n.btn-transparent:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Icon container within transparent button */\n.btn-transparent .btn-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0; /* Prevent icon from shrinking */\n}\n\n/* Text container within transparent button */\n.btn-transparent .btn-text {\n  flex: 1;\n  text-align: left;\n}\n\n.chart-btn {\n  background: rgba(51, 51, 51, 0.3);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  padding: 8px 14px;\n  color: #d1d5db;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  font-size: 14px;\n  font-weight: 400;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.chart-btn:hover {\n  background: rgba(75, 85, 99, 0.4);\n  border-color: rgba(255, 255, 255, 0.2);\n  color: #f3f4f6;\n}\n\n.chart-btn.active {\n  background: rgba(139, 92, 246, 0.3);\n  border-color: rgba(139, 92, 246, 0.5);\n  color: #c4b5fd;\n}\n\n.chart-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.chart-btn-icon-only {\n  padding: 8px;\n  min-width: 36px;\n  justify-content: center;\n}\n\n/* Chart type selector pills container */\n.chart-type-selector {\n  display: flex;\n  gap: 0;\n  padding: 0;\n  background: rgba(51, 51, 51, 0.2);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-radius: 30px;\n  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3),\n    2px 0 2px rgba(255, 255, 255, 0.3) !important;\n  border-left: 1px solid rgba(255, 255, 255, 0.1);\n  border-right: 1px solid rgba(255, 255, 255, 0.1);\n  border-top: 1px solid rgba(255, 255, 255, 0.01);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.01);\n  align-items: center;\n  height: fit-content;\n}\n\n.chart-type-selector .chart-btn-icon-only {\n  background: transparent !important;\n  border: none !important;\n  border-radius: 30px;\n  padding: 8px 14px;\n  min-width: 40px;\n  backdrop-filter: none !important;\n  -webkit-backdrop-filter: none !important;\n  box-shadow: none !important;\n  flex: 1;\n}\n\n.chart-type-selector .chart-btn-icon-only:hover {\n  background: transparent !important;\n  border: none !important;\n  backdrop-filter: none !important;\n  -webkit-backdrop-filter: none !important;\n  box-shadow: none !important;\n}\n\n.chart-type-selector .chart-btn-icon-only.active {\n  background: rgba(255, 255, 255, 0.1125);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border-radius: 30px;\n  box-shadow: -1px 0 1px rgba(255, 255, 255, 0.15),\n    1px 0 1px rgba(255, 255, 255, 0.15) !important;\n  border-left: 0.5px solid rgba(255, 255, 255, 0.075) !important;\n  border-right: 0.5px solid rgba(255, 255, 255, 0.075) !important;\n  border-top: 0.5px solid rgba(255, 255, 255, 0.0075) !important;\n  border-bottom: 0.5px solid rgba(255, 255, 255, 0.0075) !important;\n  color: #fff;\n}\n\n/* Individual styled buttons with forecast popup styling */\n.chart-btn-styled {\n  background: rgba(51, 51, 51, 0.2);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-radius: 30px;\n  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3),\n    2px 0 2px rgba(255, 255, 255, 0.3) !important;\n  border-left: 1px solid rgba(255, 255, 255, 0.1);\n  border-right: 1px solid rgba(255, 255, 255, 0.1);\n  border-top: 1px solid rgba(255, 255, 255, 0.01);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.01);\n}\n\n.chart-btn-styled:hover {\n  background: rgba(75, 85, 99, 0.4);\n  border-left: 1px solid rgba(255, 255, 255, 0.2);\n  border-right: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.chart-input {\n  background: rgba(51, 51, 51, 0.3);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  padding: 8px 16px;\n  color: #d1d5db;\n  font-size: 14px;\n  outline: none;\n  transition: all 0.2s ease;\n}\n\n.chart-input::placeholder {\n  color: #9ca3af;\n}\n\n.chart-input:focus {\n  border-color: rgba(139, 92, 246, 0.5);\n  box-shadow: 0 0 0 2px rgba(139, 92, 246, 0.1);\n}\n\n.chart-search-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n  background: rgba(51, 51, 51, 0.3);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  padding: 8px 16px;\n  gap: 8px;\n  transition: all 0.2s ease;\n}\n\n.chart-search-container:focus-within {\n  border-color: rgba(139, 92, 246, 0.5);\n  box-shadow: 0 0 0 2px rgba(139, 92, 246, 0.1);\n}\n\n.chart-search-input {\n  background: transparent;\n  border: none;\n  outline: none;\n  color: #d1d5db;\n  font-size: 14px;\n  width: 200px;\n}\n\n.chart-search-input::placeholder {\n  color: #9ca3af;\n}\n\n/* ===== Chart Header ===== */\n.chart-title {\n  font-size: 24px;\n  color: var(--white);\n  font-weight: bold;\n}\n\n.chart-subtitle {\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.chart-price {\n  font-size: 24px;\n  color: var(--white);\n  font-weight: bold;\n}\n\n.chart-price-date {\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.chart-price-change {\n  font-size: 14px;\n  color: var(--green);\n}\n\n.chart-header-actions {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 1.5rem 0;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n/* ===== Process Steps Component ===== */\n.process-steps-container {\n  display: flex;\n  align-items: center;\n  width: 100%;\n}\n\n.process-steps-group {\n  display: flex;\n  align-items: center;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 20px;\n  overflow: hidden;\n  box-shadow: none !important;\n}\n\n.process-step-main {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  cursor: pointer;\n  padding: 12px 24px;\n  border-radius: 20px;\n  color: #fff;\n  border: none;\n  box-shadow: none;\n}\n\n.process-step-main.expanded {\n  border-radius: 20px 0 0 20px !important;\n  border: none;\n  box-shadow: none;\n  position: relative;\n  overflow: hidden;\n}\n\n.process-step-main.expanded::after {\n  content: '';\n  position: absolute;\n  top: 0;\n  right: -1px;\n  width: 2px;\n  height: 100%;\n  background: inherit;\n  z-index: 1;\n}\n\n.process-steps-expanding-wrapper {\n  display: flex;\n  align-items: center;\n  transition: all 0.4s ease-in-out;\n  max-width: 0;\n  overflow: hidden;\n  height: 100%;\n  border: none;\n  box-shadow: none;\n}\n\n.process-steps-expanding-wrapper.expanded {\n  max-width: 1000px; /* Set a max-width large enough to contain all buttons */\n}\n\n.process-step {\n  position: relative;\n}\n\n.process-step::before {\n  content: '';\n  position: absolute;\n  border-radius: 20px;\n  left: 0;\n  top: 0%;\n  bottom: 20%;\n  width: 1px;\n  background: linear-gradient(to bottom,\n              transparent 0%,\n              rgba(255, 255, 255, 0.3) 20%,\n              rgba(255, 255, 255, 0.3) 80%,\n              transparent 100%);\n  z-index: 1;\n}\n\n.process-step-btn {\n  white-space: nowrap;\n  border-radius: 0;\n  margin-left: 0;\n  padding: 16px 28px;\n  color: #fff;\n  background: transparent;\n  border: none;\n  border-left: 1px solid rgba(255, 255, 255, 0.3);\n  border-top: none;\n  border-right: none;\n  border-bottom: none;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2),\n              inset 0 1px 0 rgba(255, 255, 255, 0.05);\n  outline: none;\n  transition: all 0.3s ease;\n  gap: 12px;\n}\n.process-step-icon {\n  padding: 0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.process-step-btn:last-child {\n  border-radius: 0 20px 20px 0;\n  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2),\n              inset 0 1px 0 rgba(255, 255, 255, 0.05),\n              0 0 0 1px rgba(255, 255, 255, 0.05);\n}\n\n.process-step-btn:hover {\n  background: rgba(255, 255, 255, 0.05);\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.3),\n              inset 0 1px 0 rgba(255, 255, 255, 0.1),\n              0 0 0 1px rgba(255, 255, 255, 0.1);\n  transform: translateY(-1px);\n}\n\n\n.process-steps-expanding-wrapper.expanded .process-step-btn {\n  margin-left: 0;\n}\n\n/* Override any inherited shadows and borders from TransparentButton */\n.process-steps-expanding-wrapper .process-step-btn,\n.process-steps-expanding-wrapper .process-step-btn * {\n  box-shadow: none !important;\n  border: none !important;\n  outline: none !important;\n}\n\n.process-step-tooltip {\n  position: fixed;\n  transform: translateX(0);\n  z-index: 9999;\n  min-width: 300px;\n  max-width: 400px;\n  pointer-events: none;\n  animation: fadeInUp 0.2s ease-out;\n}\n\n.process-step-tooltip-card {\n  background: rgba(255, 255, 255, 0.05) !important;\n  backdrop-filter: blur(20px) !important;\n  border: 1px solid rgba(255, 255, 255, 0.2) !important;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3) !important;\n  padding: 20px !important;\n  border-radius: 12px !important;\n}\n\n.process-step-tooltip-title {\n  color: #ffffff;\n  margin-bottom: 12px;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.process-step-tooltip-description {\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 14px;\n  line-height: 1.5;\n  margin: 0;\n}\n\n.process-step-tooltip-arrow {\n  position: absolute;\n  top: -6px;\n  left: 20px;\n  transform: translateX(0);\n  width: 0;\n  height: 0;\n  border-left: 6px solid transparent;\n  border-right: 6px solid transparent;\n  border-bottom: 6px solid rgba(255, 255, 255, 0.2);\n}\n\n@keyframes fadeInUp {\n  from {\n    opacity: 0;\n    transform: translateX(-50%) translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(-50%) translateY(0);\n  }\n}\n\n/* ===== Co2 Value Card ===== */\n.co2-value-card {\n  margin-left: auto;\n  padding: 12px 24px;\n  border-radius: 20px;\n  background: rgba(51, 51, 51, 0.3);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  min-width: fit-content;\n  white-space: nowrap;\n}\n\n.co2-value-content {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 12px;\n}\n\n.co2-value-label {\n  font-size: 14px;\n  color: rgba(255, 255, 255, 0.7);\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.co2-value-data {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.co2-value-amount {\n  font-size: 16px;\n  color: #ffffff;\n  font-weight: 600;\n}\n\n.co2-value-icon {\n  color: #87ceeb;\n  font-size: 22px;\n}\n\n/* ===== Main Chart Styling ===== */\n.main-chart-container {\n  background: transparent;\n  padding: 0;\n  margin: 0.25rem 0;\n}\n\n.chart-area {\n  background: rgba(17, 24, 39, 0.3);\n  backdrop-filter: blur(15px);\n  -webkit-backdrop-filter: blur(15px);\n  border-radius: 12px;\n  padding: 8px 8px 12px 8px;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  margin-bottom: 16px;\n}\n\n.chart-history-navigator {\n  background: transparent;\n  padding: 0;\n  margin-top: 16px;\n}\n\n.chart-history-title {\n  color: #d1d5db;\n  font-size: 14px;\n  font-weight: 500;\n  margin-bottom: 12px;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.chart-history-subtitle {\n  color: #9ca3af;\n  font-size: 12px;\n  font-weight: 400;\n  margin-left: auto;\n}\n\n.chart-history-overview {\n  position: relative;\n  height: 120px;\n  background: transparent;\n  border-radius: 8px;\n  overflow: hidden;\n  user-select: none;\n}\n\n.chart-history-slider {\n  position: absolute;\n  top: 10px;\n  height: calc(100% - 20px);\n  background: rgba(139, 92, 246, 0.15);\n  backdrop-filter: none;\n  -webkit-backdrop-filter: none;\n  border: 2px solid rgba(139, 92, 246, 0.8);\n  border-radius: 16px;\n  cursor: grab;\n  z-index: 10;\n  transition: all 0.3s ease;\n  min-width: 20px;\n  box-shadow: 0 0 0 1px rgba(139, 92, 246, 0.3);\n}\n\n.chart-history-slider:hover {\n  background: rgba(139, 92, 246, 0.2);\n  border-color: rgba(139, 92, 246, 0.9);\n  box-shadow: 0 0 0 1px rgba(139, 92, 246, 0.4);\n}\n\n.chart-history-slider.dragging {\n  cursor: grabbing;\n  background: rgba(139, 92, 246, 0.25);\n  border-color: rgba(139, 92, 246, 1);\n  box-shadow: 0 0 0 1px rgba(139, 92, 246, 0.5);\n}\n\n.chart-history-handle {\n  position: absolute;\n  top: 50%;\n  transform: translateY(-50%);\n  width: 12px;\n  height: 24px;\n  background: rgba(139, 92, 246, 0.9);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-radius: 6px;\n  cursor: ew-resize;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);\n}\n\n.chart-history-handle::after {\n  content: \"\";\n  width: 2px;\n  height: 12px;\n  background: rgba(255, 255, 255, 0.9);\n  border-radius: 1px;\n}\n\n.chart-history-handle.left {\n  left: -6px;\n}\n\n.chart-history-handle.right {\n  right: -6px;\n}\n\n.chart-history-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 8px;\n  font-size: 12px;\n  color: #9ca3af;\n}\n\n.chart-history-info {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n}\n\n.chart-history-warning {\n  color: #f59e0b;\n  font-size: 11px;\n  background: rgba(245, 158, 11, 0.1);\n  padding: 2px 6px;\n  border-radius: 4px;\n}\n\n/* ===== Chart Legend ===== */\n.chart-legend-container {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-top: 16px;\n}\n\n.chart-legend-group {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n}\n\n.chart-legend-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 36px;\n  background: rgba(51, 51, 51, 0.1);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-radius: 30px;\n  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.15),\n    2px 0 2px rgba(255, 255, 255, 0.15) !important;\n  border-left: 1px solid rgba(255, 255, 255, 0.05);\n  border-right: 1px solid rgba(255, 255, 255, 0.05);\n  border-top: 1px solid rgba(255, 255, 255, 0.005);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.005);\n  color: #d1d5db;\n  cursor: pointer;\n  font-size: 14px;\n  font-weight: 400;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.chart-legend-btn:hover {\n  background: transparent;\n  border-left: 1px solid rgba(255, 255, 255, 0.05);\n  border-right: 1px solid rgba(255, 255, 255, 0.05);\n  color: #f3f4f6;\n}\n\n.chart-legend-btn.active {\n  background: transparent;\n  border-left: 1px solid rgba(255, 255, 255, 0.05);\n  border-right: 1px solid rgba(255, 255, 255, 0.05);\n  border-top: 1px solid rgba(255, 255, 255, 0.005);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.005);\n  color: #fff;\n}\n\n/* Value and Forecast buttons as two halves of one pill */\n.chart-legend-group {\n  display: flex;\n  gap: 0;\n  padding: 0;\n  background: rgba(51, 51, 51, 0.1);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-radius: 30px;\n  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.15),\n    2px 0 2px rgba(255, 255, 255, 0.15) !important;\n  border-left: 1px solid rgba(255, 255, 255, 0.05);\n  border-right: 1px solid rgba(255, 255, 255, 0.05);\n  border-top: 1px solid rgba(255, 255, 255, 0.005);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.005);\n  align-items: center;\n  overflow: hidden;\n  min-width: fit-content;\n}\n\n.chart-legend-group .chart-legend-btn {\n  background: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n  border-radius: 0 !important;\n  position: relative;\n  padding: 8px 24px;\n  min-width: fit-content;\n  white-space: nowrap;\n}\n\n.chart-legend-group .chart-legend-btn:not(:last-child)::after {\n  content: '';\n  position: absolute;\n  right: 0;\n  top: 20%;\n  bottom: 20%;\n  width: 1px;\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.chart-legend-group .chart-legend-btn.active {\n  background: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n  border-radius: 0 !important;\n}\n\n.chart-legend-group .chart-legend-btn:hover {\n  background: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n}\n\n.chart-legend-group.forecast-unavailable {\n  opacity: 0.6;\n}\n\n.chart-legend-btn.disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  pointer-events: none;\n}\n\n.chart-legend-btn.inactive {\n  opacity: 0.45;\n  filter: grayscale(0.4);\n}\n\n.forecast-loading-overlay {\n  position: absolute;\n  inset: 0;\n  background: rgba(3, 7, 18, 0.35);\n  backdrop-filter: blur(2px);\n  -webkit-backdrop-filter: blur(2px);\n  border-radius: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  z-index: 4;\n  pointer-events: none;\n}\n\n.forecast-loading-card {\n  min-width: 220px;\n  padding: 12px 14px;\n  border-radius: 12px;\n  background: rgba(15, 23, 42, 0.75);\n  border: 1px solid rgba(148, 163, 184, 0.2);\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.forecast-loading-placeholder {\n  width: 100%;\n  height: 10px;\n  border-radius: 999px;\n  background: linear-gradient(90deg, rgba(148, 163, 184, 0.18), rgba(148, 163, 184, 0.32), rgba(148, 163, 184, 0.18));\n  background-size: 200% 100%;\n  animation: forecast-shimmer 1.4s ease-in-out infinite;\n}\n\n.forecast-loading-placeholder-short {\n  width: 65%;\n}\n\n.forecast-loading-text {\n  font-size: 13px;\n  color: #e5e7eb;\n  font-weight: 500;\n}\n\n@keyframes forecast-shimmer {\n  0% {\n    background-position: 200% 0;\n  }\n  100% {\n    background-position: -200% 0;\n  }\n}\n\n.chart-legend-dot {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  border: 3px solid;\n  border-color: inherit;\n  background: transparent;\n}\n\n/* ===== Chart Card Container ===== */\n.chart-card-container {\n  /* background: rgba(51, 51, 51, 0.2); */\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-radius: 20px;\n  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3),\n    2px 0 2px rgba(255, 255, 255, 0.3) !important;\n  margin: 1.5rem 0;\n  overflow: hidden;\n}\n\n.chart-card-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: rgba(17, 24, 39, 0.3);\n  backdrop-filter: blur(15px);\n  -webkit-backdrop-filter: blur(15px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 16px 16px 0 0;\n  padding: 16px 20px;\n  margin-bottom: 0;\n  transition: border-radius 0.4s ease;\n}\n\n/* When collapsed, header should have rounded bottom corners */\n.chart-card-container.collapsed .chart-card-header {\n  border-radius: 16px;\n}\n\n.chart-card-title-section {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.chart-card-grid-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.grid-dots {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 2px;\n  width: 12px;\n  height: 12px;\n}\n\n.grid-dots span {\n  width: 4px;\n  height: 4px;\n  background: #9ca3af;\n  border-radius: 1px;\n}\n\n.action-icon {\n  width: 40px;\n  height: 40px;\n  object-fit: cover;\n  display: block;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.action-icon:hover {\n  opacity: 0.8;\n  transform: scale(1.05);\n}\n\n.chart-card-title {\n  color: #ffffff;\n  font-size: 16px;\n  font-weight: 600;\n  margin: 0;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.chart-card-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.chart-card-action-btn {\n  background: rgba(75, 85, 99, 0.3);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 6px;\n  padding: 0 !important;\n  color: #9ca3af;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: all 0.2s ease;\n  width: 40px;\n  height: 40px;\n  overflow: hidden;\n}\n\n.chart-card-action-btn:hover {\n  background: rgba(75, 85, 99, 0.5);\n  border-color: rgba(255, 255, 255, 0.2);\n  color: #d1d5db;\n}\n\n.chart-card-content {\n  background: rgba(17, 24, 39, 0.3);\n  backdrop-filter: blur(15px);\n  -webkit-backdrop-filter: blur(15px);\n  /* border: 1px solid rgba(255, 255, 255, 0.05); */\n  border-top: none;\n  border-radius: 0 0 16px 16px;\n  padding: 24px;\n  min-height: auto;\n  max-height: 5000px;\n  overflow: hidden;\n  transition: max-height 0.4s ease, padding 0.4s ease, opacity 0.3s ease;\n  opacity: 1;\n}\n\n.chart-card-content.collapsed {\n  max-height: 0;\n  padding-top: 0;\n  padding-bottom: 0;\n  opacity: 0;\n}\n\n/* Rotate the action icon when collapsed */\n.action-icon {\n  transition: transform 0.3s ease;\n  transform: rotate(0deg);\n}\n\n.action-icon.collapsed {\n  transform: rotate(180deg);\n}\n\n/* ===== Drag and Drop Styles ===== */\n.draggable-component {\n  cursor: default;\n  transition: opacity 0.2s ease, transform 0.2s ease;\n}\n\n.draggable-component.dragging {\n  opacity: 0.5;\n  transform: scale(0.98);\n}\n\n.drag-handle {\n  cursor: grab;\n  transition: transform 0.2s ease;\n}\n\n.drag-handle:active {\n  cursor: grabbing;\n}\n\n.drag-handle:hover {\n  cursor: grab;\n}\n\n.drag-handle:hover .grid-dots span {\n  background: #7479ff;\n}\n\n/* ===== Table & Average Layout ===== */\n.table-average-layout {\n  display: flex;\n  gap: 20px;\n  align-items: stretch;\n  width: 100%;\n}\n\n.table-section {\n  flex: 1 1 50%;\n  min-width: 0; /* Prevents flex item from overflowing */\n  max-width: 50%;\n  background: rgba(17, 24, 39, 0.4);\n  backdrop-filter: blur(15px);\n  -webkit-backdrop-filter: blur(15px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  padding: 16px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.05),\n    inset 0 1px 0 rgba(255, 255, 255, 0.1);\n  overflow: hidden; /* Prevent content overflow */\n}\n\n.chart-section {\n  flex: 1 1 50%;\n  min-width: 0; /* Prevents flex item from overflowing */\n  max-width: 50%;\n  overflow: hidden; /* Prevent content overflow */\n  display: flex;\n  flex-direction: column;\n}\n\n.chart-section > * {\n  max-width: 100%;\n  width: 100%;\n}\n\n@media (max-width: 1024px) {\n  .table-average-layout {\n    gap: 16px;\n  }\n\n  .table-section {\n    flex: 1 1 50%;\n    max-width: 50%;\n    padding: 12px;\n  }\n\n  .chart-section {\n    flex: 1 1 50%;\n    max-width: 50%;\n  }\n}\n\n@media (max-width: 768px) {\n  .table-average-layout {\n    flex-direction: column;\n    gap: 12px;\n  }\n\n  .table-section,\n  .chart-section {\n    flex: 1 1 100%;\n    max-width: 100%;\n    min-width: 0;\n  }\n\n  .table-section {\n    padding: 10px;\n  }\n}\n\n/* ===== Glass Table Improvements ===== */\n.glass-table {\n  /* background: rgba(31, 41, 55, 0.3) !important;\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n \n  overflow: hidden;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2),\n              inset 0 1px 0 rgba(255, 255, 255, 0.1); */\n  border-radius: 20px;\n}\n\n.glass-table th {\n  color: #ffffff !important;\n  font-weight: 600 !important;\n  font-size: 13px !important;\n  padding: 12px !important;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;\n  text-align: center !important;\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.glass-table td {\n  color: #ffffff !important;\n  padding: 12px !important;\n  font-size: 13px !important;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.05) !important;\n  text-align: center !important;\n  background: rgba(255, 255, 255, 0.02);\n}\n\n.glass-table tr:hover td {\n  background: rgba(255, 255, 255, 0.05) !important;\n}\n\n.glass-table .change-negative {\n  color: #ef4444 !important;\n  font-weight: 500 !important;\n}\n\n.glass-table .change-positive {\n  color: #10b981 !important;\n  font-weight: 500 !important;\n}\n\n/* ===== Risk & Recycling Layout ===== */\n.risk-recycling-grid {\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px;\n  align-items: stretch;\n}\n\n.risk-card {\n  border-radius: 1.5rem;\n  padding: 1.5rem;\n  color: white;\n  background: rgba(51, 51, 51, 0.2);\n  backdrop-filter: blur(10px);\n  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3), 2px 0 2px rgba(255, 255, 255, 0.3);\n  -webkit-backdrop-filter: blur(15px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  min-height: auto;\n  transition: all 0.3s ease;\n}\n\n.risk-card:hover {\n  background: rgba(17, 24, 39, 0.7);\n  border-color: rgba(255, 255, 255, 0.2);\n  transform: translateY(-2px);\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.1),\n    inset 0 1px 0 rgba(255, 255, 255, 0.2);\n}\n\n.risk-card-title {\n  color: #ffffff;\n  font-size: 16px;\n  font-weight: 600;\n  margin: 16px 0 12px 0;\n  text-align: center;\n}\n\n.risk-card-description {\n  color: #9ca3af;\n  font-size: 13px;\n  line-height: 1.4;\n  text-align: center;\n  margin-top: 12px;\n}\n\n@media (max-width: 1024px) {\n  .risk-recycling-grid {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n\n  .risk-card {\n    min-height: 240px;\n    padding: 20px;\n  }\n}\n\n@media (max-width: 768px) {\n  .risk-recycling-grid {\n    gap: 12px;\n  }\n\n  .risk-card {\n    min-height: 220px;\n    padding: 16px;\n  }\n}\n\n/* ===== Gauge Chart Styling ===== */\n.gauge-chart-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.gauge-chart-svg-wrapper {\n  position: relative;\n  margin-bottom: 16px;\n}\n\n.gauge-chart-value {\n  position: absolute;\n  top: 70%;\n  left: 50%;\n  transform: translateX(-50%);\n  color: #ffffff;\n  font-size: 27px;\n  font-weight: 700;\n  text-align: center;\n}\n\n.gauge-chart-title {\n  color: #ffffff;\n  font-size: 18px;\n  font-weight: 600;\n  margin: 12px 0 8px 0;\n  text-align: center;\n}\n\n.gauge-chart-description {\n  color: #9ca3af;\n  font-size: 16px;\n  line-height: 1.4;\n  text-align: center;\n  margin: 0;\n}\n\n/* ===== Risk Assessment Chart Styling ===== */\n.risk-assessment-chart-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.risk-assessment-chart-wrapper {\n  position: relative;\n  margin-bottom: 16px;\n}\n\n.risk-assessment-chart-svg-container {\n  position: relative;\n  display: inline-block;\n}\n\n.risk-assessment-center-text {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n  pointer-events: none;\n}\n\n.risk-assessment-percentage {\n  color: #ffffff;\n  font-size: 26px;\n  font-weight: 700;\n  line-height: 1;\n  margin-bottom: 2px;\n}\n\n.risk-assessment-label {\n  color: #9ca3af;\n  font-size: 16.5px;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.risk-assessment-title {\n  color: #ffffff;\n  font-size: 18px;\n  font-weight: 600;\n  margin: 12px 0 8px 0;\n  text-align: center;\n}\n\n.risk-assessment-description {\n  color: #9ca3af;\n  font-size: 16px;\n  line-height: 1.4;\n  text-align: center;\n  margin: 0;\n}\n\n.risk-assessment-progress-arc {\n  transition: stroke-dashoffset 0.8s ease-in-out;\n}\n\n/* ===== Water Filling Chart Styling ===== */\n.water-filling-chart-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n}\n\n.water-filling-chart-wrapper {\n  position: relative;\n  margin-bottom: 16px;\n}\n\n.water-filling-chart-svg-container {\n  position: relative;\n  display: inline-block;\n}\n\n.water-filling-center-text {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n  pointer-events: none;\n}\n\n.water-filling-percentage {\n  color: #ffffff;\n  font-size: 26px;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.water-filling-title {\n  color: #ffffff;\n  font-size: 18px;\n  font-weight: 600;\n  margin: 12px 0 8px 0;\n  text-align: center;\n}\n\n.water-filling-description {\n  color: #9ca3af;\n  font-size: 16px;\n  line-height: 1.4;\n  text-align: center;\n  margin: 0;\n}\n\n/* ===== Availability & Need Layout ===== */\n.availability-need-layout {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px;\n  align-items: stretch;\n  width: 100%;\n}\n\n.availability-section,\n.need-section {\n  background: rgba(17, 24, 39, 0.4);\n  backdrop-filter: blur(15px);\n  -webkit-backdrop-filter: blur(15px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 16px;\n  padding: 20px;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3), 0 0 0 1px rgba(255, 255, 255, 0.05),\n    inset 0 1px 0 rgba(255, 255, 255, 0.1);\n  min-height: 400px;\n  display: flex;\n  flex-direction: column;\n}\n\n@media (max-width: 1024px) {\n  .availability-need-layout {\n    grid-template-columns: 1fr;\n    gap: 16px;\n  }\n\n  .availability-section,\n  .need-section {\n    min-height: 350px;\n    padding: 16px;\n  }\n}\n\n@media (max-width: 768px) {\n  .availability-need-layout {\n    gap: 12px;\n  }\n\n  .availability-section,\n  .need-section {\n    min-height: 300px;\n    padding: 12px;\n  }\n}\n\n/* ===== Commodity Chart Styling ===== */\n.commodity-availability-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  padding: 0px 20px 0px 20px;\n  background: transparent;\n}\n\n.commodity-header {\n  margin-bottom: 20px;\n}\n\n.commodity-title {\n  color: #ffffff;\n  font-size: 22px;\n  font-weight: 600;\n  margin: 0 0 16px 0;\n}\n\n.commodity-data-labels {\n  display: flex;\n  flex-direction: row;\n  gap: 20px;\n  align-items: center;\n}\n\n.commodity-label {\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.commodity-chart-area {\n  flex: 1;\n  height: 240px;\n  margin-bottom: 12px;\n  display: block;\n}\n\n.commodity-description {\n  color: #9ca3af;\n  font-size: 13px;\n  line-height: 1.4;\n  margin: 0;\n  margin-top: auto;\n}\n\n/* ===== Commodity Need Projection ===== */\n.commodity-need-container {\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n  background: transparent;\n  align-items: stretch;\n}\n\n.commodity-need-title {\n  color: #ffffff;\n  font-size: 22px;\n  font-weight: 600;\n  margin: 0 0 16px 0;\n  align-self: stretch;\n}\n\n.commodity-need-chart {\n  flex: 1;\n  margin-bottom: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: stretch;\n  width: 100%;\n  overflow: visible;\n}\n\n.commodity-need-legend {\n  display: flex;\n  justify-content: flex-start;\n  gap: 24px;\n  margin-bottom: 16px;\n  margin-left: 0;\n  flex-wrap: wrap;\n}\n\n.commodity-need-legend-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.commodity-need-legend-color {\n  width: 16px;\n  height: 16px;\n  border-radius: 3px;\n}\n\n.commodity-need-legend-text {\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.commodity-need-description {\n  color: #9ca3af;\n  font-size: 13px;\n  line-height: 1.4;\n  margin: 0;\n  text-align: left;\n  width: 100%;\n}\n\n/* ===== Availability & Need Layout ===== */\n.availability-need-layout {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 16px;\n  height: 100%;\n}\n\n.availability-section {\n  background: rgba(51, 51, 51, 0.15);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-radius: 16px;\n  padding: 20px 0;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  width: 100%;\n}\n\n.need-section {\n  background: rgba(51, 51, 51, 0.15);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-radius: 16px;\n  padding: 20px 0px 20px 0px;\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  width: 100%;\n}\n\n@media (max-width: 1024px) {\n  .availability-need-layout {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n}\n\n/* ===== CO2 Calculator ===== */\n.co2-calculator-title {\n  color: #ffffff;\n  font-size: 20px;\n  font-weight: 600;\n  margin: 0 0 20px 0;\n}\n\n.co2-controls {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n}\n\n.co2-toggles {\n  display: flex;\n  align-items: center;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n\n.co2-dropdown-buttons {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.co2-chart-subtitle {\n  color: #ffffff;\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0 0 20px 0;\n}\n\n.co2-chart-area {\n  flex: 1;\n}\n\n.co2-toggle {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.co2-toggle-label {\n  color: #e6e8f0;\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.co2-toggle-switch {\n  width: 48px;\n  height: 26px;\n  border-radius: 26px;\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  display: inline-flex;\n  align-items: center;\n  padding: 2px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  position: relative;\n}\n\n.co2-toggle-switch.on {\n  background: #16d07f;\n}\n\n.co2-toggle-switch.off {\n  background: #3a3a48;\n}\n\n.co2-toggle-switch.off.price {\n  background: #cc3f3f;\n}\n\n.co2-toggle-knob {\n  width: 20px;\n  height: 20px;\n  border-radius: 20px;\n  background: rgba(255, 255, 255, 0.95);\n  transition: transform 0.3s ease;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.35);\n}\n\n.co2-toggle-switch.on .co2-toggle-knob {\n  transform: translateX(22px);\n}\n\n@media (max-width: 768px) {\n  .co2-controls {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 16px;\n  }\n\n  .co2-toggles {\n    width: 100%;\n    justify-content: flex-start;\n  }\n\n  .co2-dropdown-buttons {\n    width: 100%;\n    justify-content: flex-start;\n  }\n}\n\n/* ===== Charts Page Layout ===== */\n.charts_page {\n  padding: 20px;\n  min-height: 100vh;\n  max-width: 100vw;\n  overflow-x: hidden;\n}\n\n.charts_page .charts_content {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 20px;\n  max-width: 100%;\n}\n\n.charts_page .center_column {\n  width: 100%;\n  min-width: 0;\n}\n\n.charts_page .right_column {\n  width: 100%;\n  min-width: 0;\n  order: -1; /* Show right column (tabs) first on mobile/tablet */\n}\n\n/* Tablet breakpoint */\n@media (min-width: 768px) and (max-width: 1024px) {\n  .charts_page {\n    padding: 16px;\n  }\n\n  .charts_page .charts_content {\n    gap: 16px;\n  }\n}\n\n/* Laptop and larger screens */\n@media (min-width: 1025px) {\n  .charts_page .charts_content {\n    grid-template-columns: 1fr 380px;\n    gap: 20px;\n  }\n\n  .charts_page .center_column {\n    min-width: 0;\n    overflow: visible;\n  }\n\n  .charts_page .right_column {\n    width: 380px;\n    min-width: 320px;\n    order: 0; /* Reset order for desktop */\n  }\n}\n\n/* Large desktop screens */\n@media (min-width: 1440px) {\n  .charts_page .charts_content {\n    grid-template-columns: 1fr 420px;\n    gap: 24px;\n  }\n\n  .charts_page .right_column {\n    width: 420px;\n  }\n}\n\n/* Mobile specific adjustments */\n@media (max-width: 600px) {\n  .charts_page {\n    padding: 12px;\n  }\n\n  .charts_page .charts_content {\n    gap: 12px;\n  }\n\n  /* Add horizontal scroll for chart header actions if needed */\n  .chart-header-actions {\n    overflow-x: auto;\n    -webkit-overflow-scrolling: touch;\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n  }\n\n  .chart-header-actions::-webkit-scrollbar {\n    display: none;\n  }\n}\n\n/* ===== Supplier Tab Component Styling ===== */\n/* Main container for the supplier tab component */\n.supplier-tab-container {\n  color: #ffffff;\n}\n\n/* Header row with column labels */\n.supplier-tab-header {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr;\n  gap: 16px;\n  margin-bottom: 16px;\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.6);\n  font-weight: 500;\n}\n\n/* Container for the list of supplier cards */\n.supplier-tab-list {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n/* Individual supplier card styling */\n.supplier-tab-card {\n  transition: all 0.3s ease;\n  cursor: pointer;\n}\n\n/* Main row displaying supplier basic info */\n.supplier-tab-row {\n  display: grid;\n  grid-template-columns: 1fr 1fr 1fr auto;\n  gap: 16px;\n  align-items: center;\n}\n\n/* Supplier name styling */\n.supplier-tab-name {\n  color: #ffffff;\n  font-weight: 500;\n  font-size: 14px;\n}\n\n/* Supplier location styling */\n.supplier-tab-location {\n  color: #ffffff;\n  font-size: 14px;\n}\n\n/* Volume container with volume and percentage */\n.supplier-tab-volume {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n/* Volume text styling */\n.supplier-tab-volume-text {\n  color: #ffffff;\n  font-size: 14px;\n}\n\n/* Percentage styling with emphasis */\n.supplier-tab-percentage {\n  color: #ffffff;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n/* Chevron icon container */\n.supplier-tab-chevron {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Chevron icon styling */\n.supplier-tab-chevron-icon {\n  color: #ffffff;\n  width: 16px;\n  height: 16px;\n  transition: transform 0.2s ease;\n}\n\n/* Expanded content container with animation */\n.supplier-tab-expanded {\n  margin-top: 16px;\n  padding-top: 16px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n  animation: supplier-tab-fade-in 0.3s ease-out;\n}\n\n/* Supplier description text */\n.supplier-tab-description {\n  font-size: 13px;\n  color: rgba(255, 255, 255, 0.7);\n  line-height: 1.5;\n  margin: 0 0 16px 0;\n}\n\n/* Details grid container */\n.supplier-tab-details-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0;\n  margin-bottom: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n/* Individual detail item */\n.supplier-tab-detail-item {\n  display: flex;\n  justify-content: space-between;\n  padding: 12px 16px;\n}\n\n/* Right border for left column items */\n.supplier-tab-detail-border-right {\n  border-right: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n/* Bottom border for top/middle row items */\n.supplier-tab-detail-border-bottom {\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n/* Detail label styling */\n.supplier-tab-detail-label {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n/* Detail value styling */\n.supplier-tab-detail-value {\n  font-size: 12px;\n  color: #ffffff;\n}\n\n/* Profile button container */\n.supplier-tab-profile-button {\n  text-align: right;\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 16px;\n}\n\n/* Supplier details table */\n.supplier-tab-details-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  margin-bottom: 16px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 20px;\n  overflow: hidden;\n}\n\n.supplier-tab-detail-cell {\n  padding: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  vertical-align: top;\n}\n\n.supplier-tab-detail-cell .supplier-tab-detail-label {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.6);\n  margin-bottom: 4px;\n  font-weight: 500;\n}\n\n.supplier-tab-detail-cell .supplier-tab-detail-value {\n  color: #ffffff;\n  font-size: 13px;\n  font-weight: 500;\n}\n\n/* Fade-in animation for expanded content */\n@keyframes supplier-tab-fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* ===== COMPARE DROPDOWN STYLES ===== */\n.compare-dropdown-container {\n  position: relative;\n  display: block;\n  width: 100%;\n}\n\n.compare-dropdown-container .chart-search-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n  background: rgba(51, 51, 51, 0.2);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 20px;\n  padding: 8px 12px;\n  width: 100%;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.compare-dropdown-container .chart-search-container:hover,\n.compare-dropdown-container .chart-search-container.active {\n  border-color: rgba(255, 255, 255, 0.2);\n  background: rgba(51, 51, 51, 0.3);\n}\n\n.compare-dropdown-container .chart-search-input {\n  flex: 1;\n  background: transparent;\n  border: none;\n  outline: none;\n  color: #fff;\n  font-size: 14px;\n  font-family: 'NeoSans', sans-serif;\n  margin-left: 8px;\n  margin-right: 8px;\n  cursor: pointer;\n}\n\n.compare-dropdown-container .chart-search-input::placeholder {\n  color: rgba(255, 255, 255, 0.5);\n}\n\n.compare-dropdown-menu {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(51, 51, 51, 0.2);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-radius: 20px;\n  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3),\n    2px 0 2px rgba(255, 255, 255, 0.3) !important;\n  border-left: 1px solid rgba(255, 255, 255, 0.1);\n  border-right: 1px solid rgba(255, 255, 255, 0.1);\n  border-top: 1px solid rgba(255, 255, 255, 0.01);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.01);\n  z-index: 1000;\n  min-width: 480px;\n  width: 480px;\n  max-width: 90vw;\n  max-height: 400px;\n  overflow: hidden;\n}\n\n.compare-dropdown-tabs {\n  display: flex;\n  gap: 0;\n  padding: 12px 32px;\n  background: transparent;\n  justify-content: center;\n}\n\n.compare-dropdown-tabs .pill-container {\n  display: flex;\n  gap: 4px;\n  padding: 4px;\n  background: transparent;\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 20px;\n  width: calc(100% - 40px);\n  margin: 0 auto;\n}\n\n.compare-tab-pill {\n  flex: 1;\n  padding: 8px 20px;\n  background: transparent;\n  border: none;\n  border-radius: 16px;\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 11px;\n  font-weight: 500;\n  font-family: 'NeoSans', sans-serif;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  min-width: 120px;\n}\n\n.compare-tab-pill:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.compare-tab-pill.active {\n  background: transparent;\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n  color: #fff;\n}\n\n.compare-dropdown-list {\n  max-height: 300px;\n  overflow-y: auto;\n  padding: 8px 0;\n}\n\n.compare-dropdown-item {\n  margin: 8px 12px;\n  padding: 12px 16px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  border-radius: 20px;\n  background: rgba(51, 51, 51, 0.2);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.compare-dropdown-item:hover {\n  background: rgba(255, 255, 255, 0.05);\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n.compare-item-name {\n  color: #fff;\n  font-size: 14px;\n  font-family: 'NeoSans', sans-serif;\n  flex: 1;\n  padding-right: 16px;\n  border-right: 1px solid rgba(255, 255, 255, 0.1);\n  line-height: 1.4;\n}\n\n.compare-item-price {\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 12px;\n  font-family: 'NeoSans', sans-serif;\n  font-weight: 500;\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.compare-dropdown-empty {\n  padding: 20px 16px;\n  text-align: center;\n  color: rgba(255, 255, 255, 0.5);\n  font-size: 14px;\n  font-family: 'NeoSans', sans-serif;\n}\n\n.compare-dropdown-list {\n  scrollbar-width: none; /* Firefox */\n}\n\n.compare-dropdown-list::-webkit-scrollbar {\n  width: 0px;\n  background: transparent;\n}\n\n.compare-dropdown-list:hover::-webkit-scrollbar {\n  width: 4px;\n}\n\n.compare-dropdown-list:hover::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.compare-dropdown-list:hover::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 2px;\n}\n\n.compare-dropdown-list:hover::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n/* ===== TIMEFRAME PILLS STYLES ===== */\n.timeframe-pills-container {\n  display: flex;\n  gap: 8px;\n}\n\n.timeframe-pill {\n  padding: 8px 16px;\n  background: rgba(51, 51, 51, 0.2);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 20px;\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 12px;\n  font-weight: 500;\n  font-family: 'NeoSans', sans-serif;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 40px;\n  text-align: center;\n}\n\n.timeframe-pill:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: rgba(255, 255, 255, 0.9);\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n.timeframe-pill.active {\n  background: transparent;\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n  color: #fff;\n}\n\n.date-selector-pill {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 16px;\n  background: rgba(51, 51, 51, 0.2);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 20px;\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 12px;\n  font-weight: 500;\n  font-family: 'NeoSans', sans-serif;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.date-selector-pill:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: rgba(255, 255, 255, 0.9);\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n.date-selector-pill.active {\n  background: transparent;\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n  color: #fff;\n}\n\n/* ===== EXPORT DROPDOWN POPUP STYLES ===== */\n.export-dropdown-popup {\n  position: absolute;\n  top: calc(100% + 8px);\n  left: -100%;\n  background: rgba(51, 51, 51, 0.2);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-radius: 20px;\n  padding: 24px;\n  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3),\n    2px 0 2px rgba(255, 255, 255, 0.3) !important;\n  border-left: 1px solid rgba(255, 255, 255, 0.1);\n  border-right: 1px solid rgba(255, 255, 255, 0.1);\n  border-top: 1px solid rgba(255, 255, 255, 0.01);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.01);\n  color: #fff;\n  font-family: 'NeoSans', sans-serif;\n  z-index: 12000;\n  max-height: 500px;\n  overflow-y: auto;\n  scrollbar-width: none; /* Firefox */\n}\n\n.export-dropdown-popup::-webkit-scrollbar {\n  width: 0px;\n  background: transparent;\n}\n\n.export-dropdown-popup:hover::-webkit-scrollbar {\n  width: 4px;\n}\n\n.export-dropdown-popup:hover::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.export-dropdown-popup:hover::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 2px;\n}\n\n.export-dropdown-popup:hover::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.export-popup-title {\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0 0 20px 0;\n  color: #fff;\n}\n\n.export-product-info {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  padding: 16px;\n  margin-bottom: 20px;\n}\n\n.export-product-indicator {\n  width: 8px;\n  height: 8px;\n  background: #10B981;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.export-product-details {\n  flex: 1;\n}\n\n.export-product-name {\n  font-size: 14px;\n  font-weight: 500;\n  color: #fff;\n  margin-bottom: 4px;\n}\n\n.export-product-date {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.6);\n}\n\n.export-product-price {\n  font-size: 14px;\n  font-weight: 600;\n  color: #fff;\n}\n\n.export-timeframes-and-controls {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 20px;\n  gap: 20px;\n}\n\n.export-timeframes {\n  display: flex;\n  gap: 6px;\n  flex-wrap: nowrap;\n  flex-shrink: 0;\n}\n\n.export-timeframe-pill {\n  padding: 6px 12px;\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 16px;\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 12px;\n  font-weight: 500;\n  font-family: 'NeoSans', sans-serif;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 35px;\n  text-align: center;\n}\n\n.export-timeframe-pill:hover {\n  background: rgba(255, 255, 255, 0.15);\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.export-timeframe-pill.active {\n  background: rgba(255, 255, 255, 0.2);\n  border-color: rgba(255, 255, 255, 0.3);\n  color: #fff;\n}\n\n.export-controls-row {\n  display: flex;\n  gap: 12px;\n  align-items: center;\n  flex-shrink: 0;\n}\n\n.export-dropdown-container {\n  position: relative;\n}\n\n.export-dropdown-btn {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 16px;\n  color: rgba(255, 255, 255, 0.8);\n  font-size: 12px;\n  font-weight: 500;\n  font-family: 'NeoSans', sans-serif;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 80px;\n}\n\n.export-dropdown-btn:hover {\n  background: rgba(255, 255, 255, 0.15);\n  border-color: rgba(255, 255, 255, 0.3);\n}\n\n.export-dropdown-btn.currency-btn .currency-symbol {\n  background: #F59E0B;\n  color: #000;\n  border-radius: 50%;\n  width: 16px;\n  height: 16px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 10px;\n  font-weight: 600;\n}\n\n.export-dropdown-menu {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  right: 0;\n  background: rgba(51, 51, 51, 0.95);\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  z-index: 1000;\n  overflow: hidden;\n}\n\n.export-dropdown-item {\n  padding: 8px 12px;\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.8);\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.export-dropdown-item:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: #fff;\n}\n\n.export-sort-section {\n  display: flex;\n  justify-content: flex-start;\n  margin-bottom: 20px;\n}\n\n.export-sort-container {\n  display: flex;\n  gap: 4px;\n  padding: 4px;\n  background: rgba(51, 51, 51, 0.2);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 20px;\n}\n\n.export-sort-btn {\n  padding: 6px 12px;\n  background: transparent;\n  border: none;\n  border-radius: 16px;\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 12px;\n  font-weight: 500;\n  font-family: 'NeoSans', sans-serif;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  min-width: 80px;\n}\n\n.export-sort-btn:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.export-sort-btn.active {\n  background: transparent;\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n  color: #fff;\n}\n\n.export-inclusion-section {\n  margin-bottom: 20px;\n}\n\n.export-inclusion-title {\n  font-size: 14px;\n  font-weight: 500;\n  color: #fff;\n  margin: 0 0 12px 0;\n}\n\n.export-inclusion-pills {\n  display: flex;\n  gap: 8px;\n}\n\n.export-inclusion-pill {\n  padding: 6px 12px;\n  background: rgba(255, 255, 255, 0.1);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n  border-radius: 16px;\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 12px;\n  font-weight: 500;\n  font-family: 'NeoSans', sans-serif;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.export-inclusion-pill:hover {\n  background: rgba(255, 255, 255, 0.15);\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.export-inclusion-pill.active {\n  background: rgba(255, 255, 255, 0.1);\n  border-color: rgba(255, 255, 255, 0.2);\n  color: #8B5CF6;\n}\n\n/* ===== FREQUENCY DROPDOWN ITEMS ===== */\n\n.frequency-dropdown-item {\n  width: 100%;\n  text-align: left;\n  padding: 8px 12px;\n  font-size: 14px;\n  background: rgba(51, 51, 51, 0.2);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  /* border-radius: 20px; */\n  color: #fff;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-family: 'NeoSans', sans-serif;\n}\n\n.frequency-dropdown-item:hover {\n  background: rgba(255, 255, 255, 0.05);\n  border-color: rgba(255, 255, 255, 0.2);\n}\n\n.frequency-dropdown-item.selected {\n  background: rgba(255, 255, 255, 0.05);\n  /* border-color: rgba(139, 92, 246, 0.4); */\n  color: #fff;\n}\n\n.frequency-dropdown-item.selected:hover {\n  background: rgba(255, 255, 255, 0.05);\n  /* border-color: rgba(139, 92, 246, 0.5); */\n}\n\n/* ===== CHART SETTINGS BUTTONS ===== */\n.chart-settings-container {\n  position: relative;\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.chart-settings-btn {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  background: rgba(51, 51, 51, 0.2);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 20px;\n  color: rgba(255, 255, 255, 0.7);\n  cursor: pointer;\n  transition: all 0.2s ease;\n  font-family: 'NeoSans', sans-serif;\n}\n\n.chart-settings-btn:hover {\n  background: rgba(255, 255, 255, 0.1);\n  border-color: rgba(255, 255, 255, 0.2);\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.chart-icon-btn {\n  border-radius: 50%;\n  color: #8B5CF6;\n}\n\n.chart-icon-image {\n  width: 18px;\n  height: 18px;\n  object-fit: contain;\n}\n\n.plus-icon-btn {\n  border-radius: 8px !important;\n  position: relative;\n  background: #fff !important;\n  padding: 8px !important;\n  width: 40px !important;\n  height: 40px !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n}\n\n.plus-icon-btn:hover {\n  background: rgba(255, 255, 255, 0.9) !important;\n}\n\n.plus-icon-btn svg {\n  color: #000 !important;\n  stroke: #000 !important;\n  stroke-width: 2.5 !important;\n  width: 20px !important;\n  height: 20px !important;\n}\n\n.chart-notification-badge {\n  position: absolute;\n  top: 2px;\n  right: 2px;\n  background: transparent;\n  color: #8B5CF6;\n  font-size: 8px;\n  font-weight: 600;\n  width: 16px;\n  height: 16px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border: 2px solid #8B5CF6;\n}\n\n/* ===== FORECAST POPUP STYLES ===== */\n.forecast-popup-overlay,\n.chart-settings-popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.2);\n  z-index: 9999;\n}\n\n.forecast-popup {\n  position: absolute;\n  top: 0;\n  left: calc(100% + 13px);\n  background: rgba(51, 51, 51, 0.2);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-radius: 20px;\n  padding: 24px;\n  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3),\n    2px 0 2px rgba(255, 255, 255, 0.3) !important;\n  border-left: 1px solid rgba(255, 255, 255, 0.1);\n  border-right: 1px solid rgba(255, 255, 255, 0.1);\n  border-top: 1px solid rgba(255, 255, 255, 0.01);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.01);\n  width: 320px;\n  color: #fff;\n  font-family: 'NeoSans', sans-serif;\n  z-index: 10000;\n}\n\n.forecast-popup-title {\n  font-size: 18px;\n  font-weight: 600;\n  margin: 0 0 24px 0;\n  color: #fff;\n}\n\n.forecast-section {\n  margin-bottom: 24px;\n}\n\n.forecast-section-title {\n  font-size: 14px;\n  font-weight: 500;\n  color: #fff;\n  margin: 0 0 12px 0;\n}\n\n.forecast-projection-pills {\n  display: flex;\n  gap: 4px;\n  padding: 4px;\n  background: rgba(51, 51, 51, 0.2);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 20px;\n}\n\n.forecast-projection-pill {\n  flex: 1;\n  padding: 8px 12px;\n  background: transparent;\n  border: none;\n  border-radius: 16px;\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 12px;\n  font-weight: 500;\n  font-family: 'NeoSans', sans-serif;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: center;\n}\n\n.forecast-projection-pill:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.forecast-projection-pill.active {\n  background: transparent;\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n  color: #8B5CF6;\n}\n\n.forecast-news-pills {\n  display: flex;\n  gap: 4px;\n  padding: 4px;\n  background: rgba(51, 51, 51, 0.2);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 20px;\n}\n\n.forecast-news-pill {\n  flex: 1;\n  padding: 8px 12px;\n  background: transparent;\n  border: none;\n  border-radius: 16px;\n  color: rgba(255, 255, 255, 0.7);\n  font-size: 12px;\n  font-weight: 500;\n  font-family: 'NeoSans', sans-serif;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-align: center;\n}\n\n.forecast-news-pill:hover {\n  background: rgba(255, 255, 255, 0.1);\n  color: rgba(255, 255, 255, 0.9);\n}\n\n.forecast-news-pill.active {\n  background: transparent;\n  backdrop-filter: blur(20px);\n  -webkit-backdrop-filter: blur(20px);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n  color: #8B5CF6;\n}\n\n.forecast-textarea {\n  width: 100%;\n  min-height: 80px;\n  padding: 12px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  color: #fff;\n  font-size: 12px;\n  font-family: 'NeoSans', sans-serif;\n  resize: vertical;\n  outline: none;\n}\n\n.forecast-textarea::placeholder {\n  color: rgba(255, 255, 255, 0.5);\n  font-style: italic;\n}\n\n.forecast-textarea:focus {\n  border-color: rgba(255, 255, 255, 0.2);\n  background: rgba(255, 255, 255, 0.08);\n}\n\n.forecast-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 24px;\n}\n\n/* ===== Custom DatePicker Styles ===== */\n.custom-datepicker-wrapper {\n  position: absolute;\n  top: 100%;\n  right: 0;\n  margin-top: 8px;\n  background: transparent;\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-radius: 20px;\n  padding: 20px;\n  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3), 2px 0 2px rgba(255, 255, 255, 0.3);\n  border-left: 1px solid rgba(255, 255, 255, 0.1);\n  border-right: 1px solid rgba(255, 255, 255, 0.1);\n  border-top: 1px solid rgba(255, 255, 255, 0.01);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.01);\n  min-width: 350px;\n  z-index: 1000;\n}\n\n.custom-datepicker-field-container {\n  margin-bottom: 16px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n}\n\n.custom-datepicker-field-container:last-of-type {\n  margin-bottom: 20px;\n}\n\n.custom-datepicker-label {\n  color: #9CA3AF;\n  font-size: 12px;\n  display: block;\n  margin-bottom: 6px;\n}\n\n.custom-datepicker-input {\n  width: 100% !important;\n  padding: 10px 12px;\n  background: transparent;\n  border: 2px solid rgba(255, 255, 255, 0.1);\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);\n  border-radius: 8px;\n  color: #D1D5DB;\n  font-size: 14px;\n  outline: none;\n  cursor: pointer;\n  box-sizing: border-box;\n}\n\n.custom-datepicker-input:focus {\n  border-color: rgba(139, 92, 246, 0.5);\n}\n\n.custom-datepicker-actions {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-end;\n}\n\n.datepicker-btn {\n  padding: 8px 16px;\n  border-radius: 6px;\n  cursor: pointer;\n  font-size: 14px;\n  border: 1px solid;\n  transition: all 0.2s ease;\n}\n\n.datepicker-btn-cancel {\n  background: rgba(75, 85, 99, 0.3);\n  border-color: rgba(156, 163, 175, 0.2);\n  color: #9CA3AF;\n}\n\n.datepicker-btn-cancel:hover {\n  background: rgba(75, 85, 99, 0.5);\n}\n\n.datepicker-btn-apply {\n  background: rgba(139, 92, 246, 0.8);\n  border-color: rgba(139, 92, 246, 0.5);\n  color: #fff;\n  font-weight: 500;\n}\n\n.datepicker-btn-apply:hover {\n  background: rgba(139, 92, 246, 1);\n}\n\n.datepicker-btn-apply:disabled {\n  background: rgba(75, 85, 99, 0.3);\n  border-color: rgba(75, 85, 99, 0.3);\n  color: #6B7280;\n  cursor: not-allowed;\n}\n\n/* React DatePicker Calendar Styling */\n.react-datepicker {\n  background: rgba(30, 33, 44, 0.85) !important;\n  backdrop-filter: blur(10px) !important;\n  -webkit-backdrop-filter: blur(10px) !important;\n  border-radius: 20px !important;\n  border: 1px solid rgba(255, 255, 255, 0.1) !important;\n  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3), 2px 0 2px rgba(255, 255, 255, 0.3) !important;\n  font-family: 'NeoSans', sans-serif !important;\n  padding: 16px !important;\n}\n\n.react-datepicker__header {\n  background: transparent !important;\n  border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;\n  padding: 12px 0 !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  gap: 8px !important;\n  top: -4px !important;\n}\n\n.react-datepicker__current-month,\n.react-datepicker-time__header,\n.react-datepicker-year-header {\n  display: none !important;\n}\n\n.react-datepicker__day-name,\n.react-datepicker__day,\n.react-datepicker__time-name {\n  color: #D1D5DB !important;\n  width: 2rem !important;\n  line-height: 2rem !important;\n  margin: 0.2rem !important;\n}\n\n.react-datepicker__day--weekend {\n  color: #EF4444 !important;\n}\n\n.react-datepicker__day:hover {\n  background: rgba(139, 92, 246, 0.3) !important;\n  border-radius: 8px !important;\n}\n\n.react-datepicker__day--selected,\n.react-datepicker__day--in-selecting-range,\n.react-datepicker__day--in-range {\n  background: rgba(139, 92, 246, 0.6) !important;\n  color: #fff !important;\n  border-radius: 8px !important;\n}\n\n.react-datepicker__day--keyboard-selected {\n  background: rgba(139, 92, 246, 0.4) !important;\n  border-radius: 8px !important;\n}\n\n.react-datepicker__day--disabled {\n  color: rgba(156, 163, 175, 0.3) !important;\n  cursor: not-allowed !important;\n}\n\n.react-datepicker__navigation {\n  top: 30px !important;\n}\n\n.react-datepicker__navigation-icon::before {\n  border-color: #D1D5DB !important;\n}\n\n.react-datepicker__navigation:hover *::before {\n  border-color: #fff !important;\n}\n\n.react-datepicker__triangle {\n  display: none !important;\n}\n\n.react-datepicker__month {\n  margin: 0.8rem !important;\n  padding-top: 0.4rem !important;\n}\n\n/* Year and Month Dropdown Selectors */\n.react-datepicker__year-dropdown-container,\n.react-datepicker__month-dropdown-container {\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  margin: 0 2px !important;\n}\n\n.react-datepicker__year-dropdown-container select,\n.react-datepicker__month-dropdown-container select,\n.react-datepicker__year-dropdown,\n.react-datepicker__month-dropdown,\nselect.react-datepicker__month-select,\nselect.react-datepicker__year-select {\n  background: rgba(60, 66, 81, 0.8) !important;\n  border: 1px solid rgba(255, 255, 255, 0.2) !important;\n  border-radius: 6px !important;\n  color: #D1D5DB !important;\n  padding: 10px 8px !important;\n  font-size: 13px !important;\n  font-family: 'NeoSans', sans-serif !important;\n  cursor: pointer !important;\n  transition: all 0.2s ease !important;\n  appearance: none !important;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23D1D5DB' d='M6 9L1 4h10z'/%3E%3C/svg%3E\") !important;\n  background-repeat: no-repeat !important;\n  background-position: right 8px center !important;\n  padding-right: 28px !important;\n}\n\n.react-datepicker__year-dropdown-container select:hover,\n.react-datepicker__month-dropdown-container select:hover,\n.react-datepicker__year-dropdown:hover,\n.react-datepicker__month-dropdown:hover,\nselect.react-datepicker__month-select:hover,\nselect.react-datepicker__year-select:hover {\n  background-color: rgba(75, 85, 99, 0.9) !important;\n  border-color: rgba(139, 92, 246, 0.5) !important;\n}\n\n.react-datepicker__year-dropdown-container select:focus,\n.react-datepicker__month-dropdown-container select:focus,\n.react-datepicker__year-dropdown:focus,\n.react-datepicker__month-dropdown:focus,\nselect.react-datepicker__month-select:focus,\nselect.react-datepicker__year-select:focus {\n  outline: none !important;\n  background-color: rgba(75, 85, 99, 1) !important;\n  border-color: rgba(139, 92, 246, 0.7) !important;\n  box-shadow: 0 0 0 2px rgba(139, 92, 246, 0.25) !important;\n}\n\n.react-datepicker__year-dropdown-container select option,\n.react-datepicker__month-dropdown-container select option,\nselect.react-datepicker__month-select option,\nselect.react-datepicker__year-select option {\n  background: rgba(30, 33, 44, 0.95) !important;\n  color: #D1D5DB !important;\n  padding: 8px !important;\n}\n\n.forecast-btn {\n  flex: 1;\n  padding: 12px 20px;\n  border: none;\n  border-radius: 10px;\n  font-size: 12px;\n  font-weight: 600;\n  font-family: 'NeoSans', sans-serif;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n}\n\n.forecast-btn-cancel {\n  background: rgba(239, 68, 68, 0.2);\n  border: 1px solid rgba(239, 68, 68, 0.3);\n  color: #EF4444;\n}\n\n.forecast-btn-cancel:hover {\n  background: rgba(239, 68, 68, 0.3);\n  border-color: rgba(239, 68, 68, 0.5);\n}\n\n.forecast-btn-apply {\n  background: rgba(139, 92, 246, 0.2);\n  border: 1px solid rgba(139, 92, 246, 0.3);\n  color: #8B5CF6;\n}\n\n.forecast-btn-apply:hover {\n  background: rgba(139, 92, 246, 0.3);\n  border-color: rgba(139, 92, 246, 0.5);\n}\n\n/* ===== NEWS TAB CONTENT STYLES ===== */\n#insights {\n  height: 70vh;\n  overflow-y: auto;\n  scrollbar-width: none; /* Firefox */\n}\n\n#insights::-webkit-scrollbar {\n  width: 0px;\n  background: transparent;\n}\n\n#insights:hover::-webkit-scrollbar {\n  width: 4px;\n}\n\n#insights:hover::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.05);\n}\n\n#insights:hover::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 2px;\n}\n\n#insights:hover::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n/* ===== CHART SETTINGS POPUP STYLES ===== */\n.chart-settings-popup {\n  position: absolute;\n  top: 60px;\n  left: 0;\n  background: rgba(51, 51, 51, 0.2);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-radius: 20px;\n  padding: 24px;\n  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3),\n    2px 0 2px rgba(255, 255, 255, 0.3);\n  border-left: 1px solid rgba(255, 255, 255, 0.1);\n  border-right: 1px solid rgba(255, 255, 255, 0.1);\n  border-top: 1px solid rgba(255, 255, 255, 0.01);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.01);\n  width: 850px;\n  color: #fff;\n  font-family: 'NeoSans', sans-serif;\n  z-index: 10000;\n}\n\n.chart-settings-title {\n  font-size: 18px;\n  font-weight: 700;\n  letter-spacing: 2px;\n  margin-bottom: 24px;\n  color: #fff;\n}\n\n.chart-settings-header {\n  display: grid;\n  grid-template-columns: 2fr 1fr 1fr 1fr;\n  gap: 16px;\n  padding: 12px 16px;\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.6);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.chart-settings-items {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  margin-bottom: 24px;\n}\n\n.chart-settings-item {\n  display: grid;\n  grid-template-columns: 2fr 1fr 1fr 1fr;\n  gap: 16px;\n  align-items: center;\n  padding: 16px;\n  background: rgba(255, 255, 255, 0.05);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 12px;\n  transition: all 0.2s ease;\n}\n\n.chart-settings-item:hover {\n  background: rgba(255, 255, 255, 0.08);\n  border-color: rgba(255, 255, 255, 0.15);\n}\n\n.chart-settings-item-name {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n/* Custom color picker */\n.cs-color-picker-wrap {\n  position: relative;\n  flex-shrink: 0;\n}\n\n.cs-color-swatch {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  border: 2px solid rgba(255, 255, 255, 0.25);\n  cursor: pointer;\n  padding: 0;\n  transition: border-color 0.2s, transform 0.15s;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.35);\n}\n\n.cs-color-swatch:hover {\n  border-color: rgba(255, 255, 255, 0.55);\n  transform: scale(1.08);\n}\n\n.cs-color-popover {\n  position: absolute;\n  top: calc(100% + 10px);\n  left: 0;\n  z-index: 10100;\n  width: 196px;\n  padding: 14px;\n  border-radius: 16px;\n  background: rgba(28, 30, 44, 0.92);\n  backdrop-filter: blur(16px);\n  -webkit-backdrop-filter: blur(16px);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.55), 0 0 0 0.5px rgba(255,255,255,0.06) inset;\n}\n\n.cs-color-presets {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 8px;\n  margin-bottom: 12px;\n}\n\n.cs-color-preset {\n  width: 32px;\n  height: 32px;\n  border-radius: 50%;\n  border: 2px solid transparent;\n  cursor: pointer;\n  padding: 0;\n  transition: transform 0.15s, border-color 0.15s;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.3);\n}\n\n.cs-color-preset:hover {\n  transform: scale(1.15);\n  border-color: rgba(255, 255, 255, 0.5);\n}\n\n.cs-color-preset.active {\n  border-color: #fff;\n  transform: scale(1.1);\n}\n\n.cs-color-hex-row {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  background: rgba(255, 255, 255, 0.06);\n  border: 1px solid rgba(255, 255, 255, 0.1);\n  border-radius: 10px;\n  padding: 6px 10px;\n}\n\n.cs-color-hex-preview {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  flex-shrink: 0;\n  border: 1px solid rgba(255,255,255,0.2);\n}\n\n.cs-color-hex-input {\n  flex: 1;\n  background: transparent;\n  border: none;\n  outline: none;\n  color: #fff;\n  font-size: 13px;\n  font-family: 'NeoSans', monospace;\n  letter-spacing: 1px;\n  min-width: 0;\n}\n\n.chart-settings-item-price {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.chart-settings-dropdown {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  background: rgba(51, 51, 51, 0.2);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-radius: 20px;\n  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3),\n    2px 0 2px rgba(255, 255, 255, 0.3);\n  border-left: 1px solid rgba(255, 255, 255, 0.1);\n  border-right: 1px solid rgba(255, 255, 255, 0.1);\n  border-top: 1px solid rgba(255, 255, 255, 0.01);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.01);\n  color: #fff;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.chart-settings-dropdown:hover {\n  background: rgba(75, 85, 99, 0.4);\n  border-left: 1px solid rgba(255, 255, 255, 0.2);\n  border-right: 1px solid rgba(255, 255, 255, 0.2);\n}\n\n.currency-icon {\n  font-size: 14px;\n}\n\n.dropdown-arrow {\n  font-size: 10px;\n  opacity: 0.6;\n}\n\n.chart-settings-dropdown-menu {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  background: rgba(51, 51, 51, 0.594);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.063);\n  border-radius: 8px;\n  padding: 4px;\n  min-width: 180px;\n  max-height: 200px;\n  overflow-y: auto;\n  z-index: 10001;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.188);\n}\n\n.chart-settings-dropdown-menu::-webkit-scrollbar {\n  width: 4px;\n}\n\n.chart-settings-dropdown-menu::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.chart-settings-dropdown-menu::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 2px;\n}\n\n.chart-settings-dropdown-menu::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n\n.chart-settings-dropdown-item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 8px 12px;\n  color: #fff;\n  font-size: 13px;\n  cursor: pointer;\n  border-radius: 6px;\n  transition: all 0.2s ease;\n}\n\n.chart-settings-dropdown-item:hover {\n  background: rgba(255, 255, 255, 0.1);\n}\n\n.chart-settings-dropdown:disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n.chart-settings-dropdown-item.active {\n  background: rgba(255, 255, 255, 0.12);\n}\n\n.chart-settings-dropdown-group {\n  padding: 6px 12px 2px;\n  font-size: 11px;\n  color: #9CA3AF;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  border-top: 1px solid rgba(255, 255, 255, 0.08);\n  margin-top: 4px;\n}\n\n.chart-settings-conversion-hint {\n  margin-top: 4px;\n  font-size: 11px;\n  line-height: 1.3;\n  color: #9CA3AF;\n  max-width: 160px;\n}\n\n/* Hinweis zur Umrechnung unter dem Chart */\n.chart-conversion-note {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 4px 12px;\n  margin-top: 8px;\n  font-size: 11px;\n  line-height: 1.4;\n  color: #9CA3AF;\n}\n\n.chart-conversion-note-item[title] {\n  cursor: help;\n  text-decoration: underline dotted rgba(156, 163, 175, 0.6);\n  text-underline-offset: 2px;\n}\n\n.chart-conversion-note-warning {\n  color: #F59E0B;\n}\n\n.chart-settings-tabs {\n  display: inline-flex;\n  gap: 0;\n  padding: 0;\n  margin-bottom: 24px;\n  background: rgba(51, 51, 51, 0.2);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-radius: 30px;\n  box-shadow: -2px 0 2px rgba(255, 255, 255, 0.3),\n    2px 0 2px rgba(255, 255, 255, 0.3) !important;\n  border-left: 1px solid rgba(255, 255, 255, 0.1);\n  border-right: 1px solid rgba(255, 255, 255, 0.1);\n  border-top: 1px solid rgba(255, 255, 255, 0.01);\n  border-bottom: 1px solid rgba(255, 255, 255, 0.01);\n  align-items: center;\n  overflow: hidden;\n}\n\n.chart-settings-tab {\n  padding: 4px 18px;\n  background: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n  backdrop-filter: none !important;\n  -webkit-backdrop-filter: none !important;\n  border-radius: 30px;\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  flex: 1;\n  min-width: fit-content;\n}\n\n.chart-settings-tab:hover {\n  background: transparent !important;\n  border: none !important;\n  box-shadow: none !important;\n  backdrop-filter: none !important;\n  -webkit-backdrop-filter: none !important;\n}\n\n.chart-settings-tab.active {\n  background: rgba(255, 255, 255, 0.1);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border-radius: 30px;\n  box-shadow: -1px 0 1px rgba(255, 255, 255, 0.15),\n    1px 0 1px rgba(255, 255, 255, 0.15) !important;\n  border-left: 0.5px solid rgba(255, 255, 255, 0.1) !important;\n  border-right: 0.5px solid rgba(255, 255, 255, 0.1) !important;\n  border-top: 0.5px solid rgba(255, 255, 255, 0.01) !important;\n  border-bottom: 0.5px solid rgba(255, 255, 255, 0.01) !important;\n  color: #fff;\n}\n\n.chart-settings-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n.chart-settings-btn {\n  padding: 10px 32px;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  letter-spacing: 1px;\n  cursor: pointer;\n  transition: all 0.2s ease;\n}\n\n.chart-settings-btn-cancel {\n  background: #dc2626;\n  border: 1px solid #dc2626;\n  color: #fff;\n}\n\n.chart-settings-btn-cancel:hover {\n  background: #b91c1c;\n  border-color: #b91c1c;\n}\n\n.chart-settings-btn-save {\n  background: rgba(139, 92, 246, 0.2);\n  border: 1px solid rgba(139, 92, 246, 0.5);\n  color: #a78bfa;\n}\n\n.chart-settings-btn-save:hover {\n  background: rgba(139, 92, 246, 0.3);\n  border-color: rgba(139, 92, 246, 0.7);\n}\n\n/* ===== RESPONSIVE FONT SIZES ===== */\n/* Tablet adjustments (1025px - 1440px) */\n@media (max-width: 1440px) {\n  :root {\n    --fs-page-title: 28px;\n  }\n}\n\n/* Tablet breakpoint (768px - 1025px) */\n@media (max-width: 1025px) {\n  :root {\n    --fs-page-title: 24px;\n    --fs-section-header: 16px;\n    --fs-chart-title: 18px;\n    --fs-chart-label: 14px;\n    --fs-tab-button: 14px;\n  }\n\n  /* Adjust button font sizes for tablet */\n  .chart-btn {\n    font-size: 13px;\n    padding: 7px 12px;\n  }\n\n  .btn-transparent {\n    font-size: 13px;\n    padding: 7px 10px;\n  }\n}\n\n/* Mobile breakpoint (max-width: 768px) */\n@media (max-width: 768px) {\n  :root {\n    --fs-page-title: 20px;\n    --fs-section-header: 16px;\n    --fs-chart-title: 16px;\n    --fs-chart-label: 12px;\n    --fs-chart-text: 13px;\n    --fs-chart-small: 11px;\n    --fs-chart-tiny: 10px;\n    --fs-tab-button: 12px;\n  }\n\n  /* Mobile button adjustments */\n  .chart-btn {\n    font-size: 12px;\n    padding: 6px 10px;\n  }\n\n  .btn-transparent {\n    font-size: 12px;\n    padding: 6px 8px;\n  }\n\n  /* Smaller padding for glass cards on mobile */\n  .glass-card-ui {\n    padding: 12px;\n    border-radius: 16px;\n  }\n}\n\n/* Small mobile breakpoint (max-width: 600px) */\n@media (max-width: 600px) {\n  :root {\n    --fs-page-title: 18px;\n    --fs-chart-title: 15px;\n  }\n\n  .glass-card-ui {\n    padding: 10px;\n  }\n}\n\n/* ===== SUPPLIER TAB STYLES ===== */\n\n/* ===== Availability & Need Vertical Override ===== */\n.availability-need-layout {\n  display: flex !important;\n  flex-direction: column !important;\n  gap: 20px !important;\n  width: 100%;\n}\n\n.availability-section,\n.need-section {\n  width: 100% !important;\n  min-height: 420px;\n}\n\n@media (max-width: 1024px) {\n  .availability-need-layout {\n    gap: 16px !important;\n  }\n\n  .availability-section,\n  .need-section {\n    min-height: 340px;\n  }\n}\n\n/* Remove browser focus outline on Recharts SVG and wrappers */\n.recharts-wrapper,\n.recharts-wrapper:focus,\n.recharts-wrapper:focus-visible,\n.recharts-wrapper:focus-within,\n.recharts-wrapper svg,\n.recharts-wrapper svg:focus,\n.recharts-wrapper svg:focus-visible,\n.recharts-surface,\n.recharts-surface:focus,\n.recharts-surface:focus-visible,\n.recharts-wrapper *:focus,\n.recharts-wrapper *:focus-visible {\n  outline: none !important;\n  outline-style: none !important;\n  outline-width: 0 !important;\n  outline-color: transparent !important;\n  box-shadow: none !important;\n  -webkit-box-shadow: none !important;\n}\n\n.recharts-wrapper {\n  -webkit-tap-highlight-color: transparent;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
